import React from 'react';
import moment from 'moment';
import $ from 'jquery';
import {
    REACT_APP_NAME,
    REACT_APP_HOST,
    REACT_APP_BASE_URL,
    REACT_APP_QB_MODE,
    REACT_APP_OPD_APP_TYPE,
    REACT_APP_BASE_URL_IPD,
    REACT_APP_URL_EMR_EXTERNAL,
    REACT_APP_URL_EMR_EXTERNAL_FETCH,
    REACT_APP_VONAGE_INCOMING_CALL_SOCKET,
    REACT_APP_PUBNUB_PUBLISH_KEY,
    REACT_APP_PUBNUB_SUBSCRIBE_KEY,
    CoreBaseAPI,
    CoreInventoryAPI,
    timezoneOffsetMinutes,
    clientEnvironment
} from '../GlobalConfig';

export const APP_NAME = REACT_APP_NAME;
export const REACT_APP_BASE_URL_SaleToPatient= REACT_APP_BASE_URL_IPD;
//Training Data URL and static Authorization token
export const TRAINING_DATA_API = 'https://api3.voiceai.myhealthcare.life/api/steps'
export const TRAINING_DATA_AUTH_TOKEN = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJpYXQiOjE1ODAxMjA1NzJ9.Dxt82xQNynJo4BKqRPNnnG6Tvs7KsfkGLBfWMNYPmFE"

/** || React Base URL */
export const API_URL_HIS_BASE = CoreBaseAPI;
export const API_URL_HIS_INVENTORY = CoreInventoryAPI;
export const API_BASE_URL = REACT_APP_BASE_URL;
export const API_BASE_URL_NURSE = API_BASE_URL + 'nurse/';
export const API_HOST = REACT_APP_HOST;
export const MYHC_APPTYPE = REACT_APP_OPD_APP_TYPE; /* This value should be one of the keys of APPS_USERTYPES */
export const VONAGE_INCOMING_CALL_SOCKET = REACT_APP_VONAGE_INCOMING_CALL_SOCKET;
export const PUBNUBPUBLISHKEY = REACT_APP_PUBNUB_PUBLISH_KEY;
export const PUBNUBSUBSCRIBEKEY = REACT_APP_PUBNUB_SUBSCRIBE_KEY;

/** || React Base URL FOR IPD */
export const API_BASE_URL_IPD = REACT_APP_BASE_URL_IPD;
export const API_URL_EMR_EXTERNAL = REACT_APP_URL_EMR_EXTERNAL;
export const API_URL_EMR_EXTERNAL_FETCH = REACT_APP_URL_EMR_EXTERNAL_FETCH;

export const API_BASE_URL_NURSE_IPD = API_BASE_URL_IPD + 'nurse/';

export const PATIENT_DATA = (params) => `${API_BASE_URL}this_visit?${params.reference_id ? 'reference_id=' + params.reference_id : 'patient_id=' + params.patient_id}`;
export const PATIENT_DATA_IPD = (params) =>
  `${API_BASE_URL}this_visit?${params.reference_id
    ? "reference_id=" + params.reference_id + "&reference_type=" + params.reference_type
    : "patient_id=" + params.patient_id
  }`;
export const LOGIN = `${API_BASE_URL}login`;
export const OTP_LOGIN = `${API_BASE_URL}otp-login`;
export const OTP_VERIFY = `${API_BASE_URL}verify-otp`;
export const LOGOUT = `${API_BASE_URL}logout`;
export const SYNC_TOKEN = `${API_BASE_URL}sync-token`;
export const SYNC_TOKEN_MHEA = `${API_BASE_URL}sync-token-mhea`;
export const PATIENT_QUEUE = `${API_BASE_URL}patient-queue`;
export const PATIENT_INFO = (params) => `${API_BASE_URL}this_visit?patient_id=${params.patient_id}&reference_id=${params.reference_id}`;
export const PAUSEOPD = `${API_BASE_URL}pause-opd`;
export const SEARCH_PATIENT = `${API_BASE_URL}patient/search`;
export const SEARCH_EXISTING = `${API_BASE_URL}patient/existing`;
export const REGISTER_PATIENT = `${API_BASE_URL}patient/register`;
export const TEMPLATE_SEARCH = `${API_BASE_URL}template/search`;
export const DELETE_TEMPLATE = `${API_BASE_URL}delete/template`;
export const FAVORITE_TEMPLATE = `${API_BASE_URL}template/favourite`;
export const VIEW_TEMPLATE = `${API_BASE_URL}view/template`;
export const EDIT_TEMPLATE = `${API_BASE_URL}edit/template`;
export const ORDERSET_SEARCH = `${API_BASE_URL}orderset/search`;
export const DELETE_ORDERSET = `${API_BASE_URL}orderset/delete`;
export const FAVORITE_ORDERSET = `${API_BASE_URL}orderset/updatefavorite`;
export const VIEW_ORDERSET = `${API_BASE_URL}view/orderset`;
export const APPLY_ORDERSET = (params) => `${API_BASE_URL}orderset/apply/${params.orderset_id}/${params.patient_id}/${params.reference_type}/${params.reference_id}`;
export const HOSPITAL_CONFIG = `${API_BASE_URL}module/hospital-config`;
export const PRACTICE_STATUS = `${API_BASE_URL}practice-status`;
export const TOGGLE_PRACTICE = `${API_BASE_URL}toggle-practice`;
export const CALENDAR_DATA = `${API_BASE_URL}calender/patients`;
export const CALENDAR_DOCTOR_LEAVE = `${API_BASE_URL}calender/leave`;
export const CALENDAR_PATIENT_LIST = `${API_BASE_URL}calender/appointment/list`;
export const CALENDAR_PATIENT_BOOK = `${API_BASE_URL}calender/appointment/book`;
export const CALENDAR_PATIENT_CANCEL = `${API_BASE_URL}calender/appointment/cancel`;
export const CALENDAR_PATIENT_SLOTS = `${API_BASE_URL}calender/booking/slots`;
export const CALENDAR_SLOTS_BLOCKED = `${API_BASE_URL}calender/slots/block`;
export const CALENDAR_SLOTS_UNBLOCKED = `${API_BASE_URL}calender/slots/unblock`;
export const SOAP_CONFIGURATION_LIST = `${API_BASE_URL}module/list`;
export const SOAP_CONFIGURATION_STORE = `${API_BASE_URL}configuration/store`;
export const PROFILE = (params) => `${params.is_doctor ? API_BASE_URL : API_BASE_URL_NURSE}profile`;
export const PROFILE_UPDATE = `${API_BASE_URL}profile/update`;
export const CHANGE_PASSWORD = `${API_BASE_URL}change-password`;
export const SEARCH_DIAGNOSIS = `${API_BASE_URL}diagnose`;
export const FAVOURITE_DIAGNOSIS = `${API_BASE_URL}diagnosis/favourite`;
export const TODAYS_VISIT = `${API_BASE_URL}todays-visit`;
export const SEARCH_DRUGS = `${API_BASE_URL}drug/search`;
export const DRUGS_CONSTANT = `${API_BASE_URL}drugs/constants`;
export const DRUG = `${API_BASE_URL}drug`;
export const DRUG_FAVOURITE = `${API_BASE_URL}drug/favourite`;
export const LAB_TEST_FAVOURITE = `${API_BASE_URL}lab-tests/favourite`;
export const LAB_TEST_SEARCH = `${API_BASE_URL}lab/test/search`;
export const LAB_TEST_CONSTANTS = `${API_BASE_URL}tests/constants`;
export const INSTRUCTION_SEARCH = `${API_BASE_URL}instructions/getAll`;
export const ORDERSET_CREATE = `${API_BASE_URL}orderset/create`;
export const CIMS_INFO = `${REACT_APP_BASE_URL_IPD}cimsplus/drug-info`;
export const CIMSINTERACTION = `${REACT_APP_BASE_URL_IPD}cimsplus/drug-interaction`;
export const ALL_CIMS_INTERACTION = `${REACT_APP_BASE_URL_IPD}cimsplus/all-drug-interaction`;
export const CIMS_DIAGNOSIS_INTERACTION = `${REACT_APP_BASE_URL_IPD}cimsplus/diagnosis-interaction`;
export const CIMS_ALLERGY_INTERACTION = `${REACT_APP_BASE_URL_IPD}cimsplus/allergies-interaction`;
export const CIMS_INFO_d = `${REACT_APP_BASE_URL_SaleToPatient}cimsplus/drug-info`;
export const CIMSINTERACTION_d = `${REACT_APP_BASE_URL_SaleToPatient}cimsplus/drug-interaction`;
export const CIMSCONFIGURATION = `${REACT_APP_BASE_URL_IPD}doctor-cims-alert-configuration-details`;
export const CIMSCONFIGURATIONUPDATE = `${REACT_APP_BASE_URL_IPD}doctor-cims-alert-configuration-update`;
export const RxDelivery_CIMS_INFO = `${REACT_APP_BASE_URL_SaleToPatient}cimsplus/all-drug-interaction`;
export const CIMS_ALLERGY_SEARCH = `${REACT_APP_BASE_URL_IPD}cimsplus/allergy-search`;
export const CIMS_AUDIT_STORE = `${REACT_APP_BASE_URL_IPD}cimsplus/cims-report`

export const CIMS_INTERACTION = (params) =>
  `${REACT_APP_BASE_URL_IPD}cimsplus/drug-interaction?drugIds=${params.drugIds}&referenceId=${params.referenceId}&referenceType=${params.referenceType}&enterpriseId=${params.enterpriseId}&FacilityId=${params.FacilityId}&StoreId=${params.StoreId}&patientId=${params.patientId}&orederSetId=${params.orederSetId}&careProtoColId=${params.careProtoColId}&doctorId=${params.doctorId}&selectedId=${params.selectedId}&medicineScreen=${params.medicineScreen}`;
export const CIMS_INTERACTION_EXISTS = (params) =>
  `${REACT_APP_BASE_URL_IPD}cimsplus/drug-interaction-exists?drugIds=${params.drugIds}&referenceId=${params.referenceId}&referenceType=${params.referenceType}&enterpriseId=${params.enterpriseId}&FacilityId=${params.FacilityId}&StoreId=${params.StoreId}&patientId=${params.patientId}&orederSetId=${params.orederSetId}&careProtoColId=${params.careProtoColId}&doctorId=${params.doctorId}&selectedId=${params.selectedId}&medicineScreen=${params.medicineScreen}`;
export const CIMS_DIAGNOSIS_INTERACTION_EXISTS = (params) =>
  `${REACT_APP_BASE_URL_IPD}cimsplus/diagnosis-interaction-exists?drugIds=${0}&referenceId=${params.referenceId}&referenceType=${params.referenceType}&enterpriseId=${params.enterpriseId}&FacilityId=${params.FacilityId}&StoreId=${params.StoreId}&patientId=${params.patientId}&orederSetId=${0}&careProtoColId=${params.careProtoColId}&medicineScreen=${params.medicineScreen}&addedAssessmentList=${params.addedAssessmentList}&doctorId=${params.doctorId}`;
export const CIMS_ALLERGY_INTERACTION_EXISTS = (params) =>
  `${REACT_APP_BASE_URL_IPD}cimsplus/allergies-interaction-exists?drugIds=${0}&referenceId=${params.referenceId}&referenceType=${params.referenceType}&enterpriseId=${params.enterpriseId}&FacilityId=${params.FacilityId}&StoreId=${params.StoreId}&patientId=${params.patientId}&orederSetId=${0}&careProtoColId=${params.careProtoColId}&medicineScreen=${params.medicineScreen}&addedAssessmentList=${params.addedAssessmentList}&doctorId=${params.doctorId}`;
export const Demo_CIMS_INTERACTION_EXISTS = (params) =>
    `${REACT_APP_BASE_URL_SaleToPatient}cimsplus/drug-interaction-exists?drugIds=${params.drugIds}&referenceId=${params.referenceId}&referenceType=${params.referenceType}&enterpriseId=${params.enterpriseId}&FacilityId=${params.FacilityId}&StoreId=${params.StoreId}&patientId=${params.patientId}&orederSetId=${params.orederSetId}&careProtoColId=${params.careProtoColId}&doctorId=${params.doctorId}&selectedId=${params.selectedId}&medicineScreen=${params.medicineScreen}`;
export const Demo_CIMS_INTERACTION = (params) =>
    `${REACT_APP_BASE_URL_SaleToPatient}cimsplus/drug-interaction?drugIds=${params.drugIds}&referenceId=${params.referenceId}&referenceType=${params.referenceType}&enterpriseId=${params.enterpriseId}&FacilityId=${params.FacilityId}&StoreId=${params.StoreId}&patientId=${params.patientId}&orederSetId=${params.orederSetId}&careProtoColId=${params.careProtoColId}&doctorId=${params.doctorId}&selectedId=${params.selectedId}&medicineScreen=${params.medicineScreen}`;
export const ALL_CIMS_INTERACTION_EXISTS = (params) =>
    `${REACT_APP_BASE_URL_IPD}cimsplus/all-drug-interaction-exists?drugIds=${params.drugIds}&referenceId=${params.referenceId}&referenceType=${params.referenceType}&enterpriseId=${params.enterpriseId}&FacilityId=${params.FacilityId}&StoreId=${params.StoreId}&patientId=${params.patientId}&orederSetId=${params.orederSetId}&careProtoColId=${params.careProtoColId}&medicineScreen=${params.medicineScreen}&addedAssessmentList=${params.addedAssessmentList}&doctorId=${params.doctorId}`;
export const RxDelivery_CIMS = (params) =>
    `${REACT_APP_BASE_URL_SaleToPatient}cimsplus/all-drug-interaction?drugIds=${params.drugIds}&referenceId=${params.referenceId}&referenceType=${params.referenceType}&enterpriseId=${params.enterpriseId}&FacilityId=${params.FacilityId}&StoreId=${params.StoreId}&patientId=${params.patientId}&orederSetId=${params.orederSetId}&careProtoColId=${params.careProtoColId}&doctorId=${params.doctorId}&selectedId=${params.selectedId}&medicineScreen=${params.medicineScreen}`;
export const RxDelivery_CIMS_EXISTS = (params) =>
    `${REACT_APP_BASE_URL_SaleToPatient}cimsplus/all-drug-interaction-exists?drugIds=${params.drugIds}&referenceId=${params.referenceId}&referenceType=${params.referenceType}&enterpriseId=${params.enterpriseId}&FacilityId=${params.FacilityId}&StoreId=${params.StoreId}&patientId=${params.patientId}&orederSetId=${params.orederSetId}&careProtoColId=${params.careProtoColId}&doctorId=${params.doctorId}&selectedId=${params.selectedId}&medicineScreen=${params.medicineScreen}`;


export const CREATE_TEMPLATE = `${API_BASE_URL}create/template`;
export const CHECK_LATE_ALERT_STATUS = `${API_BASE_URL}late-alert-status`;
export const LATE_ALERT = `${API_BASE_URL}late-alert`;
export const REFERAL_INFORMATION = `${API_BASE_URL}referal_information`;
export const REFERRAL_LIST = `${API_BASE_URL}list/referral`;
export const SUBJECTIVE_INFRMATION = (params) => `${API_BASE_URL}subjectives/${params.reference_type}/${params.reference_id}`; // type is 0 and reference id is qms_token_id
export const SUBJECTIVE_STORE = `${API_BASE_URL}subjectives/store`;
export const COMPLETED_DOCTOR_VISIT = (params) => `${API_BASE_URL}completed-doctor-visit/${params.patient_id}/${params.doctor_id}`;
export const OBJECTIVE_GETALL = (params) => `${API_BASE_URL}objective/getAll/${params.patient_id}`;
export const PDF_CONFIG_VITALS_GRAPH = (params) => `${API_BASE_URL}pdf-configuration/vitals-graph/${params.reference_type}/${params.reference_id}`;
export const PDF_CONFIG_VITALS_GRAPH_UPDATE = `${API_BASE_URL}pdf-configuration/vitals-graph`;
export const VITALS_GRAPH = (params) => `${API_BASE_URL}objective/vitals-graph/${params.patient_id}${params?.start_date !== undefined ? `?start_date=${params.start_date}&end_date=${params.end_date}` : ''}`;
export const VITAL_GRAPH_DATE = (params) => `${API_BASE_URL}objective/vitals/graph/${params.patient_id}?${params.date}`;
export const EXISTING_CONDITION_LIST = (params) => `${API_BASE_URL}objective/getAll/${params.patient_id}/conditions`;
export const EXISTING_CONDITION_DELETE = (params) => `${API_BASE_URL}objective/condition/delete/${params.history_id}`;
export const SURGICAL_HISTORY_LIST = (params) => `${API_BASE_URL}objective/getAll/${params.patient_id}/surgical-histories`;
export const ALLERGIES_GETALL = (params) => `${API_BASE_URL}objective/getAll/${params.patient_id}/allergies`;
export const MEDICINES_GETALL = (params) => `${API_BASE_URL}objective/getAll/${params.patient_id}/current-medicines`;
export const GET_VISIT_VITALS = (params) => `${API_BASE_URL}objective/getAll/${params.patient_id}/vitals/${params.reference_type}/${params.reference_id}`;
export const VITALS_GETALL = (params) => `${API_BASE_URL}objective/getAll/${params.patient_id}/vitals`;
export const HISTORY_DELETE = (params) => `${API_BASE_URL}objective/${params.type}/delete/${params.id}`;
export const SURGICAL_HISTORY_DELETE = (params) => `${API_BASE_URL}objective/surgical-history/delete/${params.history_id}`;
export const FAMILY_HISTORY_LIST = `${API_BASE_URL}familyHistory`;
export const FAMILY_HISTORY_DELETE = (params) => `${API_BASE_URL}delete/relation/${params.history_id}`;
export const FAMILY_STORE = `${API_BASE_URL}patient/save/objective`;
export const SOCIALHX_LIST = `${API_BASE_URL}getSocialHx`;
export const SOCIAL_HISTORY_DELETE = (params) => `${API_BASE_URL}delete/socialHx/${params.history_id}`;
export const SOCIAL_HISTORY_UPDATE = `${API_BASE_URL}patient/save/PatientHistory`;
export const DISEASE_SEARCH = `${API_BASE_URL}disease`;
export const RELATIONSHIP_SEARCH = `${API_BASE_URL}relationship`;
export const KEY_FINDINGS_GRAPH = `${API_BASE_URL}patient-test-result/graph`;
export const DETAIL_LIST_API = (params) => `${API_BASE_URL}test-record/detail-list?search=${params.search}&is_abnormal=${params.is_abnormal}&patientId=${params.patient_id}&startdate=${params.startdate}&enddate=${params.enddate}`;
export const KEY_FINDING_STORE = `${API_BASE_URL}key-findings/store`;
export const SOCIALHX_HISTORY_DELETE = (params) => `${API_BASE_URL}delete/socialHx/${params.history_id}`;
export const OBJECTIVE_STORE = `${API_BASE_URL}objective/store`;
export const OBJECTIVE_VITAL_STORE = `${API_BASE_URL}objective/vitals/store`;

export const KEY_FINDINGS_LIS = `${API_BASE_URL_IPD}keyfindings/vital_keyfindings_lis`;
export const KEY_FINDINGS_LIS_STORE_NOTES = `${API_BASE_URL_IPD}keyfindings/keyfindings_lis_store_notes`;

export const CONDITION_SEARCH = `${API_BASE_URL}condition`;
export const ALLERGIES_DROPDOWN = (params) => `${API_BASE_URL}allergies?${params.search && params.search.length > 0 ? 'search=' + params.search : ''}&type[]=${params.type}`;
export const PHR_DOCS = `${API_BASE_URL}getPhrDetails/{patientId}`;
export const TEST_RESULTS = `${API_BASE_URL}patient-test-results`;
export const TEST_RESULT_INFO = `${API_BASE_URL}patient-test-result/{code}`;
export const TEST_RESULT_GRAPH = `${API_BASE_URL}patient-test-result/graph`;
export const PAST_VISIT_PRIMARY_DETAILS = `${API_BASE_URL}past-visit-primary-details`;
export const PAST_VISIT_COMPLETE_DETAILS = `${API_BASE_URL}past-visit-complete-details`;
export const AUDIO_CALL = `${API_HOST}patient/audio-call`;
// export const VONAGE_CALL_API = `${API_BASE_URL}vonage/call`;
export const VONAGE_CALL_API = `${API_BASE_URL}doctor/vonage/call`;
// export const VONAGE_CALL_NOTIFY = (params) => `${API_BASE_URL}vonage/booking/${params.bookingId}/status/${params.type}`;
export const VONAGE_CALL_NOTIFY = `${API_BASE_URL}doctor/vonage/status`;
// export const CALL_RATING = `${API_BASE_URL}call`;
export const CALL_RATING = `${API_BASE_URL}vonage/state`;
export const ASSESSMENT_DELETE = params => `${API_BASE_URL}assessments/delete/${params.id}`;
export const ASSESSMENT_STORE = `${API_BASE_URL}assessments/store`;
export const ASSESSMENT_API = (params) => `${API_BASE_URL}assessments/${params.reference_type}/${params.reference_id}`;
export const ASSESSMENT_STATUS_UPDATE = (params) => `${API_BASE_URL}assessments/update-status?assessmentID=${params.id}&status=${params.status}`;
export const ASSESSMENT_LIST = `${API_BASE_URL}template/list`;
export const PRESCRIPTION_DATA = (params) => `${API_BASE_URL}prescription/${params.patient_id}/${params.reference_type}/${params.reference_id}`;
export const SOAP_DETAILS = `${API_BASE_URL}visit/details`;
export const VIEW_VISIT = `${API_BASE_URL}view/visit`;
export const DOCTOR_LIST = `${API_BASE_URL}doctor/list`;
export const SPECIALITY_LIST = `${API_BASE_URL}speciality/list`;
export const SAVE_REFERRAL = `${API_BASE_URL}save/referral`;
export const DELETE_REFERRAL = `${API_BASE_URL}delete/referral`;
export const PHYSIO_UPADTE = `${API_BASE_URL}visit/physiotherapy/update`;
export const ADMIS_UPADTE = `${API_BASE_URL}visit/admission/update`;
export const FOLLOWUP_UPDATE = `${API_BASE_URL}visit/follow-up/update`;
export const FOLLOWUP_UPDATE_BOOKING = `${API_BASE_URL}visit/follow-up/update-booking`;
export const TESTS_DELETE = (params) => `${API_BASE_URL}test/delete/${params}`;
export const ADMISSION_UPDATE = `${API_BASE_URL}visit/hospital-admission/update`;
export const COMPLETE_APPOINTEMENT = `${API_BASE_URL}complete-patient-visit`;
export const IMAGE_LIBRARY = `${API_BASE_URL}assessments/imagesLibrary`;
export const PLAN_TEST_ADVICED_STORE = `${API_BASE_URL}test/store`;
export const PLAN_TEST_ADVICED_LIST = (params) => `${API_BASE_URL}test/${params.patient_id}/${params.reference_type}/${params.reference_id}`;
export const INSTRUCTION_STORE = `${API_BASE_URL}instructions/store`;
export const INSTRUCTION_DELETE = (params) => `${API_BASE_URL}instructions/delete/${params.instruction_id}/${params.reference_type}/${params.reference_id}`;
export const PRESCRIPTION_STORE = `${API_BASE_URL}prescription/store`;
export const COPY_PRESCRIPTION = `${API_BASE_URL}copy-prescription`;
export const COPY_VISIT_APPLY = `${API_BASE_URL}template/apply`;
export const BASIC_STORE = `${API_BASE_URL}visit/basic`;
export const GET_BASIC_DATA = `${API_BASE_URL}get/visit/basic`;
export const DELETE_MEDICINE = params => `${API_BASE_URL}prescription/delete/${params.id}`;
export const DELETE_TEST = params => `${API_BASE_URL}test/delete/${params.id}`;
export const REQUEST_PIN = `${API_BASE_URL}request-pin`;
export const VERIFY_PIN = `${API_BASE_URL}verify-pin`;
export const SAVE_PIN = `${API_BASE_URL}save-pin`;
export const CHAT_API = `${API_BASE_URL}chat-list`;
export const SAVE_CHAT_TIME = `${API_BASE_URL}doctors/save-chat-time`;
export const ALL_PRESCRIPTIONS = `${API_BASE_URL}past-visit-others`;
export const VISIT_COUNT = `${API_BASE_URL}previous/visit`;
export const NO_KNOWN_OBJECTIVE = `${API_BASE_URL_IPD}objective/no-known-objective/update`;
// export const KARDIA_ECG = params => `https://mhappapis.vc.myhealthcare.co/api/patients/web/v2/patients/ecg?mrn=${params.kardiaMrn}&page=${params.pagination}`;
export const KARDIA_ECG = params => `${API_BASE_URL}patient/ecg?mrn=${params.kardiaMrn}&page=${params.pagination}`;
export const ALLERGIES_N_CONDITIONS = (params) => `${API_BASE_URL}objective/getAll/${params.patient_id}`;
export const GET_ADDENDUM = `${API_BASE_URL}visit/get/addendum`;
export const STORE_ADDENDUM = `${API_BASE_URL}visit/addendum`;
export const UPDATE_VITALS = `${API_BASE_URL}objective/vitals/update`;

/** || HOMECARE APIS */

// IPD APIs which are OPD replica
export const ALLERGIES_DROPDOWN_IPD = (params) => `${API_BASE_URL_IPD}allergies?${params.search && params.search.length > 0 ? 'search=' + params.search : ''}&type[]=${params.type}`;
//export const VITALS_GRAPH_IPD = (params) => `${API_BASE_URL_IPD}objective/vitals/graph/${params.patient_id}${params?.start_date !== undefined ? `?start_date=${params.start_date}&end_date=${params.end_date}` : ''}`;
export const VITALS_GRAPH_IPD = (params) => `${API_URL_EMR_EXTERNAL_FETCH}objective/vitals-graph/${params.patient_id}${params?.start_date !== undefined ? `?start_date=${params.start_date}&end_date=${params.end_date}` : ''}`;
export const CHECK_CRITICAL_ALERT_API_IPD = `${API_BASE_URL_IPD}vitals/criticalAlertCheck`;
export const ACKNOWLEDGE_CRITICAL_ALERT_API_IPD = `${API_BASE_URL_IPD}vitals/acknowledgeCriticalAlert`;
export const CRITICAL_ALERT_PATIENTS_API_IPD = `${API_BASE_URL_IPD}vitals/getAllActiveAlertPatient`;
export const ADD_ALERT_DETAILS_API_IPD = `${API_BASE_URL_IPD}vitals/addAlertDetails`;
export const OBJECTIVE_GETALL_IPD = `${API_BASE_URL_IPD}objective/getAll`;
export const OBJECTIVE_GETALL_IPD_FOR_VITAL_PRINT = `${API_BASE_URL_IPD}objective/getAll/vitalAllPrint`;
export const Blood_tranfusion_save = `${API_BASE_URL_IPD}ipdemr/blood_transfusion_forms_save`;
export const GET_SMART_SUGGESTION = `${API_BASE_URL_IPD}patient/visits/detail`;
export const GET_SMART_SUGGESTION_LOGS = `${API_BASE_URL_IPD}patient/suggestion/logs`;
export const SAVE_IP_ER_MYCASE_NOTE_PREFERENCE = `${API_BASE_URL_IPD}save_ip_er_mycasenote_preference`;
export const FETCH_IP_ER_MYCASE_NOTE_PREFERENCE = `${API_BASE_URL_IPD}fetch_ip_er_mycasenote_preference`;
export const GET_SMART_DIAGNOSIS_SUGGESTION = `${API_BASE_URL_IPD}patient/diagnosis/suggestion`;
// Added by vipin For the doctor handover
export const SAVE_AS_DRAFT = `${API_BASE_URL_IPD}doctor-handover-draft/save`;
export const ACKNOWLEDGE_MEDICINE_STORE = `${API_BASE_URL_IPD}store/acknowledge-meds`;
export const GET_ACKNOWLEDGE_MEDICINE = `${API_BASE_URL_IPD}get/acknowledge-meds`;
export const PUBLISH_DOCTOR_HANDOVER = `${API_BASE_URL_IPD}publish-doctor-handover/publish`;
export const DOCTOR_GET_DRAFT_RECORD = (params) => `${API_BASE_URL_IPD}doctor-get-drafted-record/${params.patientID}/${params.encounterID}`;

export const GET_HANDOVERS_LIST = (params) => `${API_BASE_URL_IPD}doctor-get-completed-record/${params.patientID}`;
export const GET_SINGLE_HANDOVERS = (params) => `${API_BASE_URL_IPD}doctor-get-single-completed-record/${params.ID}`;
// End here for doctor handover

// Routes for to Critical test results
export const GET_TEST_RESULTS_IDS = `${API_BASE_URL_IPD}fetch-patient-record-ids`;
export const STORE_TEST_REPORTS_DATA = `${API_BASE_URL_IPD}store-critical-test-results`;
export const GET_CRITICAL_TEST_ALERTS = (params) =>  `${API_BASE_URL_IPD}fetch-without-mark-ack/${params.patientId}/${params.userId}`;

// End Routes for to Critical test results
export const SPEECH_TOKEN_API = `${API_BASE_URL_IPD}speech/token`;  // Speech-to-Text token endpoint — backend issues short-lived Azure auth tokens

// Added By Vipin For the Lines and Insertion
export const GET_MASTER_SITES_LIST = `${API_BASE_URL_IPD}master/line-inser-sites`;
export const GET_MASTER_SHIFTS_LIST = `${API_BASE_URL_IPD}master/line-inser-shifts`;
export const GET_MASTER_TYPES_INSERTIONS = `${API_BASE_URL_IPD}master/insertion-types`;
export const STORE_LINES_INSERTIONS = `${API_BASE_URL_IPD}lines-insertion/save`;
export const GET_ANY_LINES_INSERTIONS_ASSOCIATED = (params) => `${API_BASE_URL_IPD}get-any-lines-insertion/${params.patientID}`;
export const MAINTENANCE_RECORD_MARK_AS_ERROR = `${API_BASE_URL_IPD}lines-insertion-maintenance-status/mark-error`;
export const STORE_LINES_INSERTIONS_MAINTENANCE_RECORD = `${API_BASE_URL_IPD}lines-insertion-maintenance-record/save`;
export const GET_MAIN_LINES_INSERTION_RECORDS = (params) => `${API_BASE_URL_IPD}lines-insertion-main-list/get/${params.patientID}/${params.encounter_id}/${params.er_encounter_id}`;
export const GET_SINGLE_LINES_INSERTION_RECORDS = `${API_BASE_URL_IPD}get-single-lines-insertion-main-list`;
export const GET_MAIN_LINES_INSERTION_HANDOVER_RECORDS = (params) => `${API_BASE_URL_IPD}get_line_insertion_active_data/${params.patientID}/${params.encounter_id}/${params.er_encounter_id}`;
export const UPDATE_STATUS_LINES_INSERTIONS = `${API_BASE_URL_IPD}lines-insertion-status/update`;
export const GET_DETAILS_LINES_INSERTION_BY_ID = (params) => `${API_BASE_URL_IPD}lines-insertion-details/get/${params.id}`;
// End for lines and Insertions
export const ASSESSMENT_API_IPD = `${API_BASE_URL_IPD}assessments`;
export const ASSESSMENT_API_IPD_FOR_ER_PATIENT = `${API_BASE_URL_IPD}get-er-patient-assessments`;
export const RELATIONSHIP_SEARCH_IPD = `${API_BASE_URL_IPD}relationship`;
export const CONDITION_SEARCH_IPD = `${API_BASE_URL_IPD}condition`;
export const SOCIALHX_LIST_IPD = `${API_BASE_URL_IPD}getSocialHx`;
export const FAMILY_HISTORY_LIST_IPD = `${API_BASE_URL_IPD}familyHistory`;
export const OBJECTIVE_STORE_IPD = `${API_BASE_URL_IPD}objective/store`;
export const OBJECTIVE_DELETE_ALLERGY = `${API_BASE_URL_IPD}objective/allergy/delete`;
export const OBJECTIVE_DELETE_CONDITION = `${API_BASE_URL_IPD}objective/condition/delete`;
export const OBJECTIVE_DELETE_SURGICAL_HISTORY = `${API_BASE_URL_IPD}objective/surgical-history/delete`;
export const OBJECTIVE_DELETE_FAMILY_HISTORY = `${API_BASE_URL_IPD}objective/family-history/delete`;
export const OBJECTIVE_DELETE_SOCIAL_HISTORY = `${API_BASE_URL_IPD}objective/social-history/delete`;
export const ASSESSMENT_STATUS_UPDATE_IPD = (params) => `${API_BASE_URL_IPD}assessments/update-status?assessmentID=${params.id}&status=${params.status}&staff_id=${params.staff_id}`;
export const ASSESSMENT_DELETE_IPD = (params) => `${API_BASE_URL_IPD}assessments/delete/${params.assessment_id}/${params.staff_id}`;
export const OBJECTIVE_VITAL_STORE_IPD = `${API_BASE_URL_IPD}objective/vitals/store`;
export const DISEASE_SEARCH_IPD = `${API_BASE_URL_IPD}disease`;
export const IMAGE_LIBRARY_IPD = `${API_BASE_URL_IPD}assessments/imagesLibrary`;
export const ASSESSMENT_STORE_IPD = `${API_BASE_URL_IPD}assessments/store`;
export const FAMILY_STORE_IPD = `${API_BASE_URL_IPD}patient/save/objective`;
export const SOCIAL_HISTORY_UPDATE_IPD = `${API_BASE_URL_IPD}patient/save/PatientHistory`;

//IPD TEMPLATES
export const DRUGS_CONSTANT_IPD = `${API_BASE_URL_IPD}drugs/constants`;
export const SEARCH_DIAGNOSIS_IPD = `${API_BASE_URL_IPD}diagnose`;
export const FAVOURITE_DIAGNOSIS_IPD = `${API_BASE_URL_IPD}diagnosis/favourite`;
export const FAVOURITE_DIAGNOSIS_IMAGE_IPD = `${API_BASE_URL_IPD}diagnosis-image/favourite`;
export const GET_FAVOURITE_DIAGNOSIS_IMAGE_IPD = `${API_BASE_URL_IPD}get/diagnosis-image-favourite/list`;
export const CREATE_TEMPLATE_IPD = `${API_BASE_URL_IPD}create/template`;
export const TEMPLATE_SEARCH_IPD = `${API_BASE_URL_IPD}template/search`;
export const DELETE_TEMPLATE_IPD = `${API_BASE_URL_IPD}delete/template`;
export const FAVORITE_TEMPLATE_IPD = `${API_BASE_URL_IPD}template/favourite`;
export const VIEW_TEMPLATE_IPD = `${API_BASE_URL_IPD}view/template`;
export const EDIT_TEMPLATE_IPD = `${API_BASE_URL_IPD}edit/template`;

//IPD Dashboard Card
export const IPD_SLOT_DETAILS = `${API_BASE_URL_IPD}slotdetails`;
export const GET_PAC_DETAILS = `${API_BASE_URL_IPD}get-pac-count`;
export const UPDATE_IPD_VISIT = `${API_BASE_URL_IPD}patient/new-visit`;
export const FETCH_PAC_DETAIL_BY_ENCOUNTER_ID = `${API_BASE_URL_IPD}get-pac-detials`;

//IPD ORDERS
export const SERVICE_TEST_SEARCH = `${API_BASE_URL_IPD}service/test/search`;
export const TEST_STORE = `${API_BASE_URL_IPD}test/store`;
export const TEST_STORE_HIS = `${API_URL_HIS_BASE}/TestOrder`;
export const TEST_DRUG_STORE = `${API_BASE_URL_IPD}test-drug/store`;
export const EXISTING_ORDERS_LIST = `${API_BASE_URL_IPD}existing-orders/list`;
export const TEST_ORDER_CANCEL = `${API_BASE_URL_IPD}existing-orders-test/cancel`;
export const ALL_ORDER_CANCEL = `${API_BASE_URL_IPD}existing-orders/cancel-all`;
export const DEPARTMENT_MASTER = `${API_BASE_URL_IPD}general/department`;
export const SUB_DEPARTMENT_MASTER = `${API_BASE_URL_IPD}general/sub-department`;
export const DRUG_IPD = `${API_BASE_URL_IPD}drug/list`;
export const ORDER_ITEM_DETAILS_BY_IPD = `${API_BASE_URL_IPD}order/item/id`;
export const ORDER_ITEM_EDIT_IPD = `${API_BASE_URL_IPD}order/item/edit`;
export const TEST_ORDER_EDIT_IPD = `${API_BASE_URL_IPD}testorder/edit`;
export const SEARCH_DRUGS_IPD = `${API_BASE_URL_IPD}drug/search`;
export const SEARCH_DRUGS_IPD_FILTERED = `${API_BASE_URL_IPD}drug/search_store_wise`;
export const DRUG_IDS_BY_GENERIC_IPD = `${API_BASE_URL_IPD}drug/search/bygeneric`;
export const DRUG_SUBSTITUTES_IPD = `${API_BASE_URL_IPD}drug/search/substitutes`;
export const SAVEMEDICATION = `${API_BASE_URL_IPD}savemedication`;
export const SAVEMEDICATIONHIS = `${API_URL_HIS_INVENTORY}/Prescription`;
export const SAVE_INDENT_MEDICATIONHIS = `${API_URL_HIS_INVENTORY}/prescription/SaveEmrMedicationOrder`;
export const ORDER_PAUSE = `${API_BASE_URL_IPD}order/pause`;
export const ORDER_STOP = `${API_BASE_URL_IPD}order/stop`;
export const ORDER_RESUME = `${API_BASE_URL_IPD}order/resume`;
export const ORDER_DELAY = `${API_BASE_URL_IPD}order/delay`;
export const ORDER_CANCEL = `${API_BASE_URL_IPD}order/cancel`;
export const INDENT_ORDER_CANCEL = `${API_BASE_URL_IPD}indent-order/cancel`;
export const GET_ORDER_TIMELINE = `${API_BASE_URL_IPD}order/timeline`;
export const GET_INDENT_ORDER_TIMELINE = `${API_BASE_URL_IPD}medicineindent-order/timeline`;
export const GET_TEST_ORDER_TIMELINE = `${API_BASE_URL_IPD}testorder/test-timeline`;
export const SAVEPATIENTAUDIT = `${API_BASE_URL_IPD}patient-audit/save`;
export const MEDICINE_PRINT_INDENT = `${API_BASE_URL_IPD}generate_medicine_print_pdf`;
export const FETCH_IPD_LOGIN_DETAILS = `${API_BASE_URL_IPD}patient_details_auto_login`;
export const GET_DRUG_PRIORITY_WISE_LIST = `${API_BASE_URL_IPD}get_drug_priority_list`;

//EMR Configuration
export const GET_FACILITY_EMR_CONFIGURATION = `${API_BASE_URL_IPD}get_emr_configuration`;
export const SAVE_FACILITY_EMR_CONFIGURATION = `${API_BASE_URL_IPD}save_emr_configuration`;
export const SAVE_FACILITY_EMR_STAFF_CONFIG = `${API_BASE_URL_IPD}save_emr_staff_config`;
export const FACILITY_EMR_STAFF_CONFIG = `${API_BASE_URL_IPD}emr_staff_config`;
// End for EMR Configuration

// IP MAR Sequence Configuration
export const GET_USER_MAR_SEQUENCE = `${API_BASE_URL_IPD}get_mar_sequence`;
export const SAVE_USER_MAR_SEQUENCE = `${API_BASE_URL_IPD}save_mar_sequence`;

//IPD REFERRALS
export const REFERRALS_STORE = `${API_BASE_URL_IPD}referrals/store`;
export const REFERRALS_LIST = `${API_BASE_URL_IPD}referrals/list`;
export const REFERRALS_DELETE = `${API_BASE_URL_IPD}referrals/delete`;
export const REFERRALS_ACCEPT = `${API_BASE_URL_IPD}referrals/accept`;
export const REFERRALS_FORWARD = `${API_BASE_URL_IPD}referrals/forward`;
export const REFERRALS_COMPLETE = `${API_BASE_URL_IPD}referrals/complete`;
export const REFERRAL_TIMELINE = `${API_BASE_URL_IPD}referrals/timeline`;

// BLOOD SUGAR MONITORING
export const BLOOD_SUGAR_STORE_IPD = `${API_BASE_URL_IPD}blood-sugar/store`;
export const BLOOD_SUGAR_LIST_IPD = (params) => `${API_BASE_URL_IPD}blood-sugar/list/${params.patient_id}/${params.reference_id}`;

export const SLIDING_SCALE_STORE_IPD = `${API_BASE_URL_IPD}sliding-scale/store`;
export const SLIDING_SCALE_LIST_IPD = (params) => `${API_BASE_URL_IPD}sliding-scale/list/${params.patient_id}`;
export const SLIDING_SCALE_GRAPH_INFO = `${API_BASE_URL_IPD}sliding-scale-graph-info`;
export const BLOOD_SUGAR_VERIFY_STORE_IPD = `${API_BASE_URL_IPD}verify-data`;
export const SLIDING_SCALE_DEFAULT_STORE_IPD = `${API_BASE_URL_IPD}blood-sugar-sliding-scale-default/store`;
export const SLIDING_SCALE_DEFAULT_LIST_IPD = (params) => `${API_BASE_URL_IPD}blood-sugar-sliding-scale-default/list/${params.patient_id}`;
export const DELETE_BLOOD_SUGAR = `${API_BASE_URL_IPD}delete-blood-sugar`;
export const BLOOD_SUGAR_TIMELINE = `${API_BASE_URL_IPD}get/blood-sugar-timeline`;
export const BLOOD_SUGAR_TYPE_MASTER = `${API_BASE_URL_IPD}blood-sugar/type_list`;

//IPD BLOOD UNIT REQUEST
export const BLOOD_GROUP_MASTER = `${API_BASE_URL_IPD}general/blood-group`;
export const BLOOD_COMPONENT_MASTER = `${API_BASE_URL_IPD}general/blood-component`;
export const LATEST_BLOOD_COUNTS = `${API_BASE_URL_IPD}blood-unit-request/blood-counts`;
export const BLOOD_REQUESTS_LIST = `${API_BASE_URL_IPD}blood-unit-request/list`;
export const Change_AddReject_Status = `${API_BASE_URL_IPD}blood-unit-request/changestatus`;
export const BLOOD_REQUESTS_STORE = `${API_BASE_URL_IPD}blood-unit-request/store`;
export const BLOOD_REQUESTS_CANCEL = `${API_BASE_URL_IPD}blood-unit-request/cancel`;
export const BLOOD_REQUESTS_CANCEL_PENDING_UNIT = `${API_BASE_URL_IPD}blood-unit-request/cancel-pending-unit`;
export const BLOOD_ISSUE_REQUEST_STORE = `${API_BASE_URL_IPD}blood-unit-request/save-issue-slip`;
export const BLOOD_ISSUED_REQUEST_GET = `${API_BASE_URL_IPD}blood-unit-request/get-issue-slip-list`;
export const GET_SAMPLE_COLLECTIONS = `${API_BASE_URL_IPD}blood-unit-request/get-sample-list`;
export const BLOOD_REQUESTS_PDF_GENERATE = `${API_BASE_URL_IPD}blood-unit-request/generate-pdf`;
export const BLOOD_REQUESTS_UPDATE = `${API_BASE_URL_IPD}blood-unit-request/update`;
export const BLOOD_BAG_RECIEVE_RETURN = `${API_BASE_URL_IPD}blood-bag/receive-return`;
export const BLOOD_BANK_DETAILS_STORE = `${API_BASE_URL_IPD}blood_bank_details_save_update`;
export const BLOOD_BANK_DETAILS_GET = `${API_BASE_URL_IPD}blood_bank_details_get`;
export const BLOOD_BANK_CANCEL_ALERT_LIST = `${API_BASE_URL_IPD}blood_bank_cancel_alert_list`;
export const BLOOD_BANK_CANCEL_ALERT_ACKNOWLEDGE = `${API_BASE_URL_IPD}blood_bank_cancel_alert_acknowledge`;
export const OT_RESCHEDULE_ALERT_ACKNOWLEDGE = `${API_BASE_URL_IPD}ot_reschedule_alert_acknowledge`;
export const OT_ACKNOWLEDGED_ALERT_LIST = `${API_BASE_URL_IPD}ot_acknowledged_alert_list`;
export const GENERATE_BLOOD_ISSUE_SLIP = `${API_BASE_URL_IPD}generate_blood_issue_slip`;
//IPD SURGERY REQUEST
export const ANATOMIC_SITE_MASTER = `${API_BASE_URL_IPD}general/anatomy-site`;
export const FAVOURITE_SURGERY_LIST = `${API_BASE_URL_IPD}surgery-request/favourite-surgery-list`;
export const MARK_FAVOURITE_SURGERY = `${API_BASE_URL_IPD}surgery-request/mark-favourite-surgery`;
export const UNMARK_FAVOURITE_SURGERY = `${API_BASE_URL_IPD}surgery-request/unmark-favourite-surgery`;
export const SURGERY_TYPE = `${API_BASE_URL_IPD}surgery-request/surgery-type`;
export const INCISION_TYPE = `${API_BASE_URL_IPD}surgery-request/incision-type`;
export const EQUIPMENT_MASTER = `${API_BASE_URL_IPD}surgery-request/surgery-equipment`;
export const IMPLANTS_MASTER = `${API_BASE_URL_IPD}surgery-request/surgery-implants`;
export const SURGERY_REQUESTS_STORE = `${API_BASE_URL_IPD}surgery-request/store`;
export const EXISTING_SURGERIES_LIST = `${API_BASE_URL_IPD}surgery-request/list`;
export const GET_SURGERY_BY_ID = `${API_BASE_URL_IPD}surgery-request/get`;
export const GET_SURGERY_TIMELINE = `${API_BASE_URL_IPD}surgery-request/timeline`;
export const SURGERY_REQUEST_CANCEL = `${API_BASE_URL_IPD}surgery-request/cancel`;
export const ANESTHESIA_TYPE_LIST = `${API_BASE_URL_IPD}anesthesia-request/anesthesia-type`;
export const SURGERY_MASTER_DETAIL = `${API_BASE_URL_IPD}surgery-master/detail`;
export const GET_OT_LIST = `${API_BASE_URL_IPD}surgery-request/ot-type`;
export const GET_OPERATION_LIST = `${API_BASE_URL_IPD}surgery-request/ot-list`;

export const GET_AVAILABLE_OT_SLOTS = `${API_BASE_URL_IPD}surgery-request/his-avialable-ot-slots`;

//IPD transfer request
export const NURSING_UNIT_DES = `${API_BASE_URL_IPD}adt/patientnursingunitlists`;
export const NURSING_UNIT_DETAILS = `${API_BASE_URL_IPD}adt/patientnursingunitdetails`;
export const BED_CATEGORY_DES = `${API_BASE_URL_IPD}adt/bad-category`;
export const REASON_LISTING = `${API_BASE_URL_IPD}emr-reason-master/list/`;
export const BED_LISTING = `${API_BASE_URL_IPD}bedlist/`;
export const DELETE_PATIENT = `${API_BASE_URL_IPD}delete-patient/`;
export const TRANSFER_REQUEST = `${API_BASE_URL_IPD}adt/save-transfer-request`;
export const IPD_BANNER = `${API_BASE_URL_IPD}ipd-banner`;
export const IPD_SPECIALITY = `${API_BASE_URL_IPD}speciality`;
export const IPD_DOCTOR = `${API_BASE_URL_IPD}doctor-list`;
export const MANUAL_PATIENT_ASSIGN = `${API_BASE_URL_IPD}manual-doctor-patient-assign`;
export const MARK_ARRIVAL = `${API_BASE_URL_IPD}save-mark-arrival`;
export const BED_STATUS_TYPE = `${API_BASE_URL_IPD}adt/bad-status-type`;
export const DISCHARGE_TYPE_LISTING = `${API_BASE_URL_IPD}discharge-type-list`;
export const INFORMED_LISTING = `${API_BASE_URL_IPD}informed-detail`;
export const INITIATE_DISCHARGE = `${API_BASE_URL_IPD}initiate-discharge-save`;
export const REASON_CANCELLATION = `${API_BASE_URL_IPD}reason-cancellation`;
export const SAVE_REASON_CANCELLATION = `${API_BASE_URL_IPD}save-reason-cancellation`;
export const SAVE_NURSING_CLEARANCE = `${API_BASE_URL_IPD}nursing-clearance`;
export const CANCEL_NURSING_CLEARANCE = `${API_BASE_URL_IPD}cancel-nursing-clearance`;
export const DISCHARGE_TIMELINE = `${API_BASE_URL_IPD}view-discharge-timeline`;
export const DISCHARGE_TEMPLATE_LIST = `${API_BASE_URL_IPD}discharge_summary/template_list`;
export const DELETE_DISCHARGE_TEMPLATE = `${API_BASE_URL_IPD}discharge_summary/delete_template_list`;
export const VIEW_DISCHARGE_SUMMARY = `${API_BASE_URL_IPD}discharge_summary/view_template`;
//ipd current orders
export const IPD_TEST_UNACK_SERVICE = `${API_BASE_URL_IPD}test/get-unack-services`;
// Common
export const STATUS_LIST = `${API_BASE_URL_IPD}status-list`;
export const STATE_LIST = `${API_BASE_URL_IPD}state-list`;
export const CITY_LIST = `${API_BASE_URL_IPD}city-list`;
export const AREA_LIST = `${API_BASE_URL_IPD}area-list`;

//IPD Discharged List
export const DISCHARGED_PATIENT_LIST = `${API_URL_HIS_BASE}/Admission/GetNursingDischargeList`;

// Doctor Appointment List for non portal dependent

export const DOCTOR_APPOINTMENT_LIST = `${API_BASE_URL_IPD}doctor/appointment/list`;
export const CALENDAR_PATIENT_LIST_IPD = `${API_BASE_URL_IPD}calender/appointment/list`;


// IPD Input Output
export const INPUT_OUTPUT_LIST = (params) => `${API_BASE_URL_IPD}get/inputoutput/list/${params.reference_type}/${params.encounter_id}/${params.patient_id}`;
export const INPUT_OUTPUT_GRAPH = `${API_BASE_URL_IPD}get/inputoutput/graph`;
export const ADD_INPUT = (params) => `${API_BASE_URL_IPD}addinput/${params.reference_type}/${params.encounter_id}/${params.patient_id}`;
export const EDIT_INPUT_OUTPUT = (params) => `${API_BASE_URL_IPD}edit-input-output/${params.reference_type}/${params.encounter_id}/${params.patient_id}`;
export const INPUT_LIST_EDIT = (params) => `${API_BASE_URL_IPD}get/inputeditlist/list/${params.reference_type}/${params.encounter_id}/${params.patient_id}`;
export const FETCH_DAILY_SUMMARY = (params) => `${API_BASE_URL_IPD}fetch-daily-summary/${params.reference_type}/${params.encounter_id}/${params.patient_id}`;
export const UPDATE_REASON = `${API_BASE_URL_IPD}updatereason`;
export const ADD_OUTPUT = (params) => `${API_BASE_URL_IPD}addoutput/${params.reference_type}/${params.encounter_id}/${params.patient_id}`;
export const DROPDOWN_LIST = `${API_BASE_URL_IPD}get/input/list`;
export const FLUID_DETAILS = (params) => `${API_BASE_URL_IPD}get/inputoutputfluid-list/${params.reference_type}/${params.encounter_id}/${params.patient_id}`;

// IPD Forms
export const IPD_FORMS_CATEGORY = `${API_BASE_URL_IPD}forms/category/list`;
export const IPD_FORMS_SUB_CATEGORY = `${API_BASE_URL_IPD}forms/subcategory/list`;
export const IPD_FORMS_NAME = `${API_BASE_URL_IPD}forms/formnames/list`;
export const IPD_FORMS_LIST = `${API_BASE_URL_IPD}forms/list`;
export const IPD_FORM_DELETE = `${API_BASE_URL_IPD}forms/delete`;
export const IPD_FORM_ERROR = `${API_BASE_URL_IPD}forms/error`;
export const IPD_FORM_VIEW = params => `${API_BASE_URL_IPD}forms/${params.id}`;
export const IPD_FORMS_ADDENDUM = `${API_BASE_URL_IPD}forms/addendum`;
export const IPD_FORMS_EDIT = `${API_BASE_URL_IPD}forms/edit`;
export const IPD_FORMS_STRUCTURE = `${API_BASE_URL_IPD}forms/formstructure`;
export const IPD_FORMS_SAVE = `${API_BASE_URL_IPD}forms/save`;
export const IPD_FORMS_AUTHORIZE = `${API_BASE_URL_IPD}forms/authorize`;
export const ORDERSET_SEARCH_IPD = `${API_BASE_URL_IPD}orderset/search`;
export const DELETE_ORDERSET_IPD = `${API_BASE_URL_IPD}orderset/delete`;
export const FAVORITE_ORDERSET_IPD = `${API_BASE_URL_IPD}orderset/updatefavorite`;
export const VIEW_ORDERSET_IPD = `${API_BASE_URL_IPD}view/orderset`;
export const ORDERSET_CREATE_IPD = `${API_BASE_URL_IPD}orderset/create`;
export const NO_OF_USE_ORDERSET_UPDATE_IPD = `${API_BASE_URL_IPD}orderset/no_of_use`;
export const LAB_TEST_CONSTANTS_IPD = `${API_BASE_URL_IPD}tests/constants`;
export const INSTRUCTION_SEARCH_IPD = `${API_BASE_URL_IPD}instructions/getAll`;
export const REFERENCE_TYPE_IPD = 0;
export const LAB_TEST_SEARCH_IPD = `${API_BASE_URL_IPD}lab/test/search`;
export const LAB_TEST_FAVOURITE_IPD = `${API_BASE_URL_IPD}lab-tests/favourite`;
export const DELETE_TEST_IPD = params => `${API_BASE_URL_IPD}test/delete/${params.id}`;
export const PLAN_TEST_ADVICED_STORE_IPD = `${API_BASE_URL_IPD}test/store`;
export const PLAN_TEST_ADVICED_LIST_IPD = (params) => `${API_BASE_URL_IPD}test/${params.patient_id}/${params.reference_type}/${params.reference_id}`;
export const HANDLETEXTAREAAUTOHEIGHT_IPD = (textarea, clear = false) => {
    const Elem = document.querySelectorAll('.' + textarea);
    if (!clear) {
        Elem.forEach((el) => { el.style.height = el.scrollHeight + "px"; });
    } else {
        Elem.forEach((el) => { el.style.height = "40px"; });
    }
}
export const MEDICINES_GETALL_IPD = (params) => `${API_BASE_URL_IPD}objective/getAll/${params.patient_id}/current-medicines`;
export const DRUG_FAVOURITE_IPD = `${API_BASE_URL_IPD}drug/favourite`;
export const CIMS_INFO_IPD = `${API_BASE_URL_IPD}cims/drug-info`;
export const CIMS_INTERACTION_EXISTS_IPD = `${API_BASE_URL_IPD}cims/drug-interaction-exists`;
export const BMI_CALCULATE_IPD = (V001, V002) => { let $weight = parseFloat(V002); let $height = parseFloat(V001); $height = $height * 0.01; let $bmi = $weight / ($height * $height); if (!isNaN($bmi)) { return $bmi.toFixed(1) } else { return ''; } }


export const PROFILE_IPD = (params) => `${params.is_doctor ? API_BASE_URL_IPD : API_BASE_URL_NURSE}profile`;
export const BSA_CALCULATE_IPD = (V001, V002) => { let $weight = parseFloat(V002); let $height = parseFloat(V001); let $bsa = Math.sqrt(($weight * $height) / 3600); if (!isNaN($bsa)) { return $bsa.toFixed(1) } else { return ''; } }
//no
export const DOSE_RULE_IPD = `${API_BASE_URL_IPD}dose/rule`;
export const AVERAGE_BSA_FOR_MALE_IPD = 1.9;
export const AVERAGE_BSA_FOR_FEMALE_IPD = 1.6;
export const IS_PAEDIATRICS_IPD = [17, 25, 36, 42, 49, 50, 56, 61, 69, 80, 110, 111, 150, 152, 163, 164, 165, 93, 112];
export const LAST_VITAL_ADDED_DATA_IPD = (params) => `${API_BASE_URL_IPD}last_vital_added?patient_id=${params.patient_id}`;

//Discharge Summary
export const Discharge_Summary_Categories = `${API_BASE_URL_IPD}discharge_summary_categories`;
export const Discharge_Summary_Get_Patient_Data = `${API_BASE_URL_IPD}patient-visit-details`;
export const Discharge_Summary_Forms = `${API_BASE_URL_IPD}discharge_summary_forms`;
export const Discharge_Summary_Get_Template = `${API_BASE_URL_IPD}discharge_summary_get_template`;
export const Discharge_Editor_Get_Template = `${API_BASE_URL_IPD}discharge_editor_get_template`;
export const Discharge_Patient_Get_Template = `${API_BASE_URL_IPD}discharge_patient_get_template`;
export const Discharge_Patient_Last_Template = `${API_BASE_URL_IPD}discharge_patient_last_template`;
export const PATIENT_DISCHARGE_SUMMARY_STATUS = `${API_BASE_URL_IPD}discharge_patient_summary_status`;
export const Discharge_Summary_Save_Template = `${API_BASE_URL_IPD}discharge_summary_save_template`;
export const Discharge_Editor_Save_Template = `${API_BASE_URL_IPD}discharge_editor_save_template`;
export const Discharge_Editor_Update_Template = `${API_BASE_URL_IPD}discharge_editor_update_template`;
export const Discharge_Summary_Get_Referral_Doctor_List = `${API_BASE_URL_IPD}doctor-list`;
export const Discharge_Summary_Get_Referral_Speciality_List = `${API_BASE_URL_IPD}speciality`;
export const Discharge_Summary_Forms_URL = `${API_BASE_URL_IPD}discharge_summary_his_form`;
export const Discharge_Summary_Patient_Forms = `${API_BASE_URL_IPD}discharge_summary_his_patient_form`;
export const Discharge_Summary_Patient_Forms_Fields = `${API_BASE_URL_IPD}discharge_summary_his_patient_form_fields`;
export const Discharge_Summary_Patient_Graphs = `${API_BASE_URL_IPD}patient_vital_graphs`;
export const Discharge_Summary_Print_PDF = `${API_BASE_URL_IPD}discharge_editor_save_pdf`;
export const Discharge_Summary_Timeline = `${API_BASE_URL_IPD}discharge_summary_updated_timeline`;
export const Discharge_Summary_Uploaded = `${API_BASE_URL_IPD}get_patient_uploaded_discharge_summary_pdf`;

/************************ Single Screen Discharge Summary Organiser - START ************************/

// 1. Configuration
export const Get_Discharge_Organiser_Template = `${API_BASE_URL_IPD}get_discharge_templatate_configurations`;
export const Save_Discharge_Organiser_Template = `${API_BASE_URL_IPD}save_discharge_templatate_configurations`;

/************************ Single Screen Discharge Summary Organiser - END ************************/

/************************ Single Screen Discharge Summary Editor - START ************************/

// 1. General data
export const Save_General_Fields = `${API_BASE_URL_IPD}save_discharge_summary_general_fields`;
export const Get_General_Fields = `${API_BASE_URL_IPD}get_discharge_summary_general_fields`;
export const Save_General_All_Fields = `${API_BASE_URL_IPD}save_all_discharge_summary_general_fields`;

// 2. Diagnosis
export const Get_Discharge_Diagnosis = `${API_BASE_URL_IPD}get_discharge_diagnosis`;
export const Save_Discharge_Diagnosis = `${API_BASE_URL_IPD}save_discharge_diagnosis`;
export const Delete_Discharge_Diagnosis = `${API_BASE_URL_IPD}delete_discharge_diagnosis`;
export const Save_Discharge_Diagnosis_Sequence = `${API_BASE_URL_IPD}save_discharge_diagnosis_sequence`;

// 3. Surgeries
export const Get_Discharge_Surgeries = `${API_BASE_URL_IPD}get_discharge_surgeries`;
export const Save_Discharge_Surgeries = `${API_BASE_URL_IPD}save_discharge_surgeries`;
export const DELETE_DISCHARGE_PATIENT_POSTED_SURGERIES = `${API_BASE_URL_IPD}delete_patient_posted_surgeries_data`;
export const REFRESH_DISCHARGE_PATIENT_POSTED_SURGERIES = `${API_BASE_URL_IPD}refresh_patient_posted_surgeries_data`;

// 4. Treatment Course
export const Get_Discharge_TreatmentCourse = `${API_BASE_URL_IPD}get_discharge_treatment_courses`;
export const Save_Discharge_TreatmentCourse = `${API_BASE_URL_IPD}save_discharge_treatment_courses`;
export const Update_Discharge_TreatmentCourse = `${API_BASE_URL_IPD}update_discharge_treatment_courses`;
export const Delete_Discharge_TreatmentCourse = `${API_BASE_URL_IPD}delete_discharge_treatment_courses`;
export const Get_Discharge_Treatment_Course_Common_Data = `${API_BASE_URL_IPD}get_patient_treatment_course_common_data`;
export const Save_And_Update_Discharge_Treatment_Course_Common_Data = `${API_BASE_URL_IPD}save_and_update_patient_treatment_course_common_data`;

// 5. Discharge Medication
export const Get_Discharge_Medication = `${API_BASE_URL_IPD}get_discharge_medication`;
export const Save_Discharge_Medication = `${API_BASE_URL_IPD}save_discharge_medication`;
export const Save_Discharge_Medication_Sequence = `${API_BASE_URL_IPD}save_discharge_medication_sequence`;

// 6. Patient History (5 sections)
export const GET_PATIENT_HISTORY_DATA = `${API_BASE_URL_IPD}get_patient_history_data`;
export const Save_PATIENT_HISTORY_DATA = `${API_BASE_URL_IPD}save_patient_history_data`;
export const GET_SAVED_PATIENT_HISTORY_DATA = `${API_BASE_URL_IPD}get_saved_patient_history_data`;
export const DELETE_DISCHARGE_PATIENT_HISTORY = `${API_BASE_URL_IPD}delete_patient_history_data`;
export const DELETE_DISCHARGE_MEDICATION = `${API_BASE_URL_IPD}delete_medication_data`;

// 7. Vitals (3 sections)
export const GET_DISCHARGE_VITALS = `${API_BASE_URL_IPD}get_discharge_vitals`;
export const SAVE_DISCHARGE_VITALS = `${API_BASE_URL_IPD}save_discharge_vitals`;
export const DELETE_DISCHARGE_VITALS = `${API_BASE_URL_IPD}delete_discharge_vitals`;
export const Get_Discharge_Vital_Common_Data = `${API_BASE_URL_IPD}get_patient_vital_common_data`;
export const Save_And_Update_Discharge_Vital_Common_Data = `${API_BASE_URL_IPD}save_and_update_patient_vital_common_data`;

// 8. Form
export const GET_LAST_SAVED_FORM_DETAILS = `${API_BASE_URL_IPD}get_last_saved_form_details`;
export const Get_Discharge_Form_Data = `${API_BASE_URL_IPD}get_patient_form_data`;
export const Get_Discharge_Form_Structured_Data = `${API_BASE_URL_IPD}get_patient_form_structured_data`;
export const Save_Discharge_Form_Data = `${API_BASE_URL_IPD}save_patient_form_data`;

// 9. Investigations
export const Get_Discharge_Result_Common_Data = `${API_BASE_URL_IPD}get_patient_test_result_common_data`;
export const Save_And_Update_Discharge_Result_Common_Data = `${API_BASE_URL_IPD}save_and_update_patient_test_result_common_data`;
export const Get_Discharge_Result_Data = `${API_BASE_URL_IPD}get_patient_test_result_data`;
export const Get_Discharge_Result_Structured_Data = `${API_BASE_URL_IPD}get_patient_test_result_structured_data`;
export const Update_Discharge_Result_Data = `${API_BASE_URL_IPD}update_patient_test_result_data`;
export const Save_Discharge_Result_Data = `${API_BASE_URL_IPD}save_patient_test_result_data`;
export const DELETE_DISCHARGE_TEST_AND_PROCEDURE = `${API_BASE_URL_IPD}delete_patient_test_result_data`;

// 10. Print / Save / Authorize
export const Discharge_Summary_Print = `${API_BASE_URL_IPD}discharge_summary_print`;
export const Discharge_Summary_Save_Form_Details = `${API_BASE_URL_IPD}save_discharge_form_details`;
export const Save_And_Cancel_Authorise_Form_Details = `${API_BASE_URL_IPD}save_and_cancel_authorise_discharge_data`;
export const Save_Draft_Disharge_Summary = `${API_BASE_URL_IPD}save_draft_discharge_summary`;
export const Discharge_Summary_Form_Refresh = `${API_BASE_URL_IPD}discharge_summary_form_refresh`;
export const Validate_Disharge_Summary = `${API_BASE_URL_IPD}discharge_summary_form_validate`;
export const Marked_Primary_Summary = `${API_BASE_URL_IPD}marked_primary_discharge_summary`;

// 11. Lab Result Data
export const Save_Lab_Result_Data = `${API_BASE_URL_IPD}save_discharge_summary_lab_result_data`;
export const Get_Lab_Result_Data = `${API_BASE_URL_IPD}get_discharge_summary_lab_result_data`;

export const Save_Radiology_Result_Data = `${API_BASE_URL_IPD}save_discharge_summary_radiology_result_data`;
export const Get_Radiology_Result_Data = `${API_BASE_URL_IPD}get_discharge_summary_radiology_result_data`;

export const Save_Procedure_Result_Data = `${API_BASE_URL_IPD}save_discharge_summary_procedure_result_data`;
export const Get_Procedure_Result_Data = `${API_BASE_URL_IPD}get_discharge_summary_procedure_result_data`;

// 12. Table Component Data
export const Save_Table_Component_Data = `${API_BASE_URL_IPD}save_discharge_summary_table_component_data`;
export const Get_Table_Component_Data = `${API_BASE_URL_IPD}get_discharge_summary_table_component_data`;

/************************ Single Screen Discharge Summary Editor - END ************************/

/************************ Anc Card - Start ************************/
export const RISK_FACTORS_LIST = `${API_BASE_URL_IPD}get-risk-factors`;
export const LAB_AND_RADIOLOGY_TESTS = `${API_BASE_URL_IPD}lab-rad/test`;
export const VaccinationList = `${API_BASE_URL_IPD}V2/vaccination/list`;
export const Get_Obs_Gyane_Data = `${API_BASE_URL_IPD}get_patient_obs_gyane_data`;
export const Save_Obs_Gyane_Data = `${API_BASE_URL_IPD}save_patient_obs_gyane_data`;
export const Save_Anc_Details = `${API_BASE_URL_IPD}save_patient_obs_gyane_anc_details`;
export const Get_Anc_Details = `${API_BASE_URL_IPD}get_patient_obs_gyane_anc_details`;
export const Get_Anc_Previous_Details = `${API_BASE_URL_IPD}get_patient_obs_gyane_anc_previous_details`;
export const Print_Anc_Details = `${API_BASE_URL_IPD}print_patient_obs_gyane_anc_details`;

// Obs & Gyane History (single screen)
export const Save_Menstrual_History = `${API_BASE_URL_IPD}save_patient_obs_gyane_menstrual_history`;
export const Save_Sexual_History = `${API_BASE_URL_IPD}save_patient_obs_gyane_sexual_history`;
export const Save_Obstetric_History = `${API_BASE_URL_IPD}save_patient_obs_gyane_obstetric_history`;
export const Save_Mother_Parameter_Data = `${API_BASE_URL_IPD}save_patient_obs_gyane_mother_parameters_data`;
export const Save_Mother_Fetus_Data = `${API_BASE_URL_IPD}save_patient_obs_gyane_mother_fetus_details`;
export const Get_Previous_Obs_Gyane_Data = `${API_BASE_URL_IPD}get_patient_previous_obs_gyane_data`;
export const Get_Previous_Mother_Fetus_History = `${API_BASE_URL_IPD}get_patient_previous_mother_fetus_history`;
export const Update_Obs_Gyane_Copy_Status = `${API_BASE_URL_IPD}update_obs_gyane_copy_status`;
export const Get_Obs_Gyane_Copy_Status = `${API_BASE_URL_IPD}get_obs_gyane_copy_status`;
export const Save_Pregnant_Audit = `${API_BASE_URL_IPD}save_patient_pregnant_audit`;
export const Get_Pregnant_Audit = `${API_BASE_URL_IPD}get_patient_pregnant_audit`;
export const Save_Lmp_Audit = `${API_BASE_URL_IPD}save_patient_lmp_audit`;
export const Get_Lmp_Audit = `${API_BASE_URL_IPD}get_patient_lmp_audit`;
export const Update_Patient_Pregnant_Status = `${API_BASE_URL_IPD}update_patient_pregnant_status`;
export const Save_Previous_Pregnancy_Details = `${API_BASE_URL_IPD}save_patient_previous_pregnancy_details`;
export const Get_Previous_Pregnancy_Details = `${API_BASE_URL_IPD}get_patient_previous_pregnancy_details`;
export const PATIENT_PREGNANCY_STATUS = `${API_BASE_URL_IPD}patient_pregnancy_status`;

// ANC Card - Investigations (Test & Procedure results attached to an ANC card)
export const LIS_ORDERS_RESULT = `${API_BASE_URL_IPD}lis_order_result`;
export const Get_Anc_Result_Common_Data = `${API_BASE_URL_IPD}get_patient_obs_gyane_anc_result_common_data`;
export const Save_And_Update_Anc_Result_Common_Data = `${API_BASE_URL_IPD}save_and_update_patient_obs_gyane_anc_result_common_data`;
export const Get_Anc_Result_Data = `${API_BASE_URL_IPD}get_patient_obs_gyane_anc_result_data`;
export const Get_Anc_Result_Structured_Data = `${API_BASE_URL_IPD}get_patient_obs_gyane_anc_result_structured_data`;
export const Save_Anc_Result_Data = `${API_BASE_URL_IPD}save_patient_obs_gyane_anc_result_data`;
export const Update_Anc_Result_Data = `${API_BASE_URL_IPD}update_patient_obs_gyane_anc_result_data`;
export const Delete_Anc_Result_Data = `${API_BASE_URL_IPD}delete_patient_obs_gyane_anc_result_data`;


/************************ Anc Card - Endf ************************/

/************************ Consent Request - START ************************/

export const PURPOSE_MASTER_LIST = `${API_BASE_URL_IPD}get_purpose_master_list`;
export const ABHA_STATUS_LIST = `${API_BASE_URL_IPD}get_abha_status_list`;
export const HEALTH_INFORMATION_TYPE_LIST = `${API_BASE_URL_IPD}get_health_information_type_list`;
export const CONSENT_REQUEST_DATA_COUNT = `${API_BASE_URL_IPD}get_consent_request_counts`;
export const CONSENT_REQUEST_LIST = `${API_BASE_URL_IPD}get_consent_request_list`;
export const SAVE_CONSENT_REQUEST = `${API_BASE_URL_IPD}save_consent_request`;
export const CONSENT_UHID_SEARCH = `${API_BASE_URL_IPD}get_patient_data_by_uhid`;

/************************ Consent Request - End ************************/


// Case Summary
export const PATIENT_VISIT_DETAILS = `${API_BASE_URL_IPD}patient_case_summary_visit_details`;
export const CASE_SUMMARY_TEMPLATE = `${API_BASE_URL_IPD}case_summary_get_template`;
export const CASE_SUMMARY_EDITOR_TEMPLATE = `${API_BASE_URL_IPD}case_summary_editor_get_template`;
export const PATIENT_CASE_SUMMARY_TEMPLATE = `${API_BASE_URL_IPD}patient_case_summary_template`;
export const PATIENT_CASE_SUMMARY_LAST_TEMPLATE = `${API_BASE_URL_IPD}patient_case_summary_last_template`;
export const CASE_SUMMARY_EDITOR_SAVE = `${API_BASE_URL_IPD}case_summary_editor_save`;
export const CASE_SUMMARY_TIMELINE = `${API_BASE_URL_IPD}case_summary_editor_timeline`;
export const CASE_SUMMARY_EDITOR_PRINT = `${API_BASE_URL_IPD}case_summary_editor_print`;

// Case Sheet
export const PATIENT_CASE_SHEET_VISIT_DETAILS = `${API_BASE_URL_IPD}patient_case_visit_details`;
export const CASE_SHEET_TEMPLATE = `${API_BASE_URL_IPD}case_sheet_get_template`;
export const CASE_SHEET_EDITOR_TEMPLATE = `${API_BASE_URL_IPD}case_sheet_editor_get_template`;
export const PATIENT_CASE_SHEET_TEMPLATE = `${API_BASE_URL_IPD}patient_case_sheet_template`;
export const PATIENT_CASE_SHEET_LAST_TEMPLATE = `${API_BASE_URL_IPD}patient_case_sheet_last_template`;
export const CASE_SHEET_EDITOR_SAVE = `${API_BASE_URL_IPD}case_sheet_editor_save`;
export const CASE_SHEET_TIMELINE = `${API_BASE_URL_IPD}case_sheet_editor_timeline`;
export const CASE_SHEET_EDITOR_PRINT = `${API_BASE_URL_IPD}case_sheet_editor_print`;

//Discharged patient list and surgery list
export const Planned_Surgery_Details = `${API_BASE_URL_IPD}planned_surgery_details`;

// Physio Report

export const GET_PHYSIO_SUMMARY_LIST = `${API_BASE_URL_IPD}get_patient_physio_summary_list`;

//Blood Bank Master
export const Blood_Master_HIS_Facility = `${API_BASE_URL_IPD}blood_master_his_facility`;
export const Blood_Master_HIS_Department = `${API_BASE_URL_IPD}blood_master_his_department`;
export const Blood_Master_HIS_Sub_Department = `${API_BASE_URL_IPD}blood_master_his_sub_department`;
export const Blood_Master_HIS_ServicesByFacility = `${API_BASE_URL_IPD}blood_master_his_services_by_facility`;
export const Blood_Master_Get_Components = `${API_BASE_URL_IPD}get_blood_component_master`;
export const Blood_Master_Get_Whole_Blood_Components = `${API_BASE_URL_IPD}get_whole_blood_component_master`;
export const Blood_Master_Component_Save = `${API_BASE_URL_IPD}blood_component_master_save`;
export const Blood_Master_Get_Common_List = `${API_BASE_URL_IPD}blood_master_common_list`;
export const Blood_Master_Common_Save_Update = `${API_BASE_URL_IPD}blood_master_common_save_update`;
export const Blood_Master_Component_By_id = `${API_BASE_URL_IPD}get_blood_component_master_by_id`;
export const ABO_Component_Save_Update = `${API_BASE_URL_IPD}abo_component_save_update`;
export const ABO_Component_Get_List = `${API_BASE_URL_IPD}abo_component_get_list`;
export const SAVE_CELL_SERUM_SCREENING = `${API_BASE_URL_IPD}donation_cell_serum_screening_save`;
export const CELL_SERUM_SCREENING_LIST = `${API_BASE_URL_IPD}donation_cell_serum_screening_list`;
export const SEARCH_DONATION_AND_BLOOD_BAGS = `${API_BASE_URL_IPD}donation_and_blood_bag_list`;
export const GET_SAVED_CELL_SERUM_SCREENING_DATA = `${API_BASE_URL_IPD}get_cell_serum_saved_data`;
//External Blood Unit 
export const External_Blood_Unit_Save = `${API_BASE_URL_IPD}external_blood_unit_save`;
export const External_Blood_Unit_Get = `${API_BASE_URL_IPD}external_blood_unit_get`;


//Blooad Request
export const Blood_BAG_Number_HIS = `${API_BASE_URL_IPD}get_blood_unit_request_list`;

export const Blood_Bag_Allocation_Save = `${API_BASE_URL_IPD}blood_bag_allocation_save`;
export const Blood_Bag_Allocation_Logs = `${API_BASE_URL_IPD}get_bood_bags_allocation_logs`;

export const Blood_Bag_Recieved = `${API_BASE_URL_IPD}get_bood_bags_recieved`;
export const Blood_Bag_Availabile_Units = `${API_BASE_URL_IPD}blood-donor/blood-bag-component-stock/units`;
export const Blood_Bag_Allocated_Units = `${API_BASE_URL_IPD}blood-donor/blood-bag-component-stock/allocate-units`;
export const GET_Blood_Bag_Available = `${API_BASE_URL_IPD}blood-donor/blood-bag-component-stock/list`;
export const Cross_Matched_Bags_Save = `${API_BASE_URL_IPD}cross_matched_bags_save`;
export const Get_Cross_Matched_Bags = `${API_BASE_URL_IPD}get_cross_matched_bags`;
export const Get_Incompatible_Bags = `${API_BASE_URL_IPD}get_incompatible_bags`;
export const Issue_Matched_Bags = `${API_BASE_URL_IPD}issue_matched_bags`;
export const Update_Issued_Bags = `${API_BASE_URL_IPD}update_issued_bags`;
export const Blood_Bag_Status_Update = `${API_BASE_URL_IPD}blood-donor/blood-bag-component-stock/change-status`;
export const Get_Patient_By_UHID = `${API_BASE_URL_IPD}get-patient-by-uhid`;
export const Get_Retun_Bag_Reason_HIS = `${API_BASE_URL_IPD}get-return-bag-reason-his`;
export const SEARCH_BLOOD_UNIT_REQUEST_IDS = `${API_BASE_URL_IPD}blood-donor/blood-bag/issued`;
export const SEARCH_BLOOD_BAG_IDS_BY_UNIT_REQUEST = `${API_BASE_URL_IPD}blood-donor/blood-bag/issued-by-blood-unit-request`;
export const ABO_COMPATIBILITY_REPORT_PRINT = `${API_BASE_URL_IPD}abo_compatibility_report_print`;
export const BLOOD_ABO_REPORTS_LIST = `${API_BASE_URL_IPD}get-blood-abo-report-list`;
export const GET_Blood_Bag_Stock_Summary = `${API_BASE_URL_IPD}blood-donor/blood-bag-component-stock/summary`;
export const ABO_COMPATIBILITY_REPORT_REPRINT = `${API_BASE_URL_IPD}abo_compatibility_report_reprint`;

//OP Blood Bank
export const OP_Cross_Matched_Bags_Save = `${API_BASE_URL_IPD}op_cross_matched_bags_save`;
export const Get_OP_Cross_Matched_Bags = `${API_BASE_URL_IPD}get_op_cross_matched_bags`;
export const Get_OP_Incompatible_Bags = `${API_BASE_URL_IPD}get_op_incompatible_bags`;
export const OP_Blood_Group_Save = `${API_BASE_URL_IPD}op_blood_group_save`;
export const Get_OP_Blood_Group = `${API_BASE_URL_IPD}op_blood_group_get`;
export const OP_BLOOD_REQUESTS_LIST = `${API_BASE_URL_IPD}blood-unit-request/oplist`;
export const Update_OP_Issued_Bags = `${API_BASE_URL_IPD}update_op_issued_bags`;
export const OP_Issue_Matched_Bags = `${API_BASE_URL_IPD}op_issue_matched_bags`;

//Blood Bank Donor
export const BLOOD_BANK_DONOR_CONSTANTS = `${API_BASE_URL_IPD}blood-donor/constants`;
export const SEARCH_BLOOD_BANK_DONATION_IDS = `${API_BASE_URL_IPD}blood-donor/donation/list`;
export const BLOOD_BANK_DONATION_BY_ID = `${API_BASE_URL_IPD}blood-donor/donation/getById`;
export const VITALS_CONSTANT_IPD = `${API_BASE_URL_IPD}vitals/constants`;
export const BLOOD_BANK_DONOR_SCREENING_STORE = `${API_BASE_URL_IPD}blood-donor/screening/save`;
export const BLOOD_BANK_DONOR_SCREENING_BY_DONATION_ID = `${API_BASE_URL_IPD}blood-donor/screening/getByDonationId`;
export const CREATE_UPDATE_DONOR = `${API_BASE_URL_IPD}blood-donor/donor/create-update`;
export const SEARCH_BLOOD_BANK_DONOR_IDS = `${API_BASE_URL_IPD}blood-donor/donor/list`;
export const BLOOD_BANK_DONOR_BY_ID = `${API_BASE_URL_IPD}blood-donor/donor/getById`;
export const CHECK_LAST_DONATION = `${API_BASE_URL_IPD}blood-donor/donor/checkLastDonation`;
export const CREATE_UPDATE_PHLEBOTOMY_DETAILS = `${API_BASE_URL_IPD}blood-donor/phlebotomy-detail/save`;
export const PHLEBOTOMY_DETAIL_BY_DONATION_ID = `${API_BASE_URL_IPD}blood-donor/phlebotomy-detail/getByDonationId`;
export const CREATE_UPDATE_BAG_SCREENING_DETAILS = `${API_BASE_URL_IPD}blood-donor/blood-bag-screening/save`;
export const BAG_SCREENING_DETAILS_BY_DONATION_ID = `${API_BASE_URL_IPD}blood-donor/blood-bag-screening/getByDonationId`;
export const CREATE_UPDATE_SCREENING_RESULT_DETAILS = `${API_BASE_URL_IPD}blood-donor/blood-bag-screening/validate`;
export const CREATED_COMPONENT_DETAILS_BY_DONATION_ID = `${API_BASE_URL_IPD}blood-donor/blood-bag-component-stock/getByDonationId`;
export const Update_StockView_Status = `${API_BASE_URL_IPD}blood-donor/blood-bag-component-stock/updateStatus`;
export const CREATE_BLOOD_BAG_COMPONENT = `${API_BASE_URL_IPD}blood-donor/blood-bag-component-stock/create`;
export const GET_BAGS_LIST_BY_BARCODE = `${API_BASE_URL_IPD}blood-donor/blood-bag-component-stock/get-bag-by-barcode`;
export const CREATE_CHILD_BAG_COMPONENT = `${API_BASE_URL_IPD}blood-donor/blood-bag-component-stock/create-child-bags`;
export const GET_BLOOD_GROUPS_ABO_COMPATIBLE = `${API_BASE_URL_IPD}abo_component_blood_group_list`;

// PRE DONATION QUESTIONAIRE
export const PRE_DONATION_QUESTIONAIRE = `${API_BASE_URL_IPD}pre_donation_questionaire/list`;
export const QUESTIONAIRE_STORE = `${API_BASE_URL_IPD}pre_donation_questionaire/save`;

//Reaction Groups
export const REACTION_GROUPS = `${API_BASE_URL_IPD}reaction_group/list`;
export const REACTION_GROUPS_STORE = `${API_BASE_URL_IPD}reaction_group/save`;

//Reaction Types
export const REACTION_TYPES = `${API_BASE_URL_IPD}reaction_types/list`;
export const REACTION_TYPES_STORE = `${API_BASE_URL_IPD}reaction_types/save`;

//IPD Blood Bags
export const BLOOD_BAGS_LIST = `${API_BASE_URL_IPD}blood_bags/list`;
export const BLOOD_BAGS_STORE = `${API_BASE_URL_IPD}blood_bags/save`;
export const BLOOD_COMPONENT_lIST = `${API_BASE_URL_IPD}blood_component_list`;

// Care Plan Count
export const CARE_PLAN_DUE_COUNT = `${API_BASE_URL_IPD}get_patient_due_ncp`;

// Medicine EMR Payload
export const EMR_MEDICINE_PAYLOAD = `${API_BASE_URL_IPD}saveMedicineLogData`;


// Equipments
export const BLOOD_EQUIPMENT_LIST = `${API_BASE_URL_IPD}equipment/list`;
export const BLOOD_EQUIPMENT_STORE = `${API_BASE_URL_IPD}equipment/save`;
export const STORAGE_LOCATION_lIST = `${API_BASE_URL_IPD}storage_location_list`;


//Donation Location
export const DONATION_LOCATION_LIST = `${API_BASE_URL_IPD}donation_location/list`;
export const DONATION_LOCATION_STORE = `${API_BASE_URL_IPD}donation_location/save`;

//Blood Bank opening stock
export const OPENING_STOCK_STORE = `${API_BASE_URL_IPD}blood-donor/blood-bag-component-opening-stock/create`;
export const BLOOD_GROUP_lIST = `${API_BASE_URL_IPD}blood_group_list`;

//Blood Bank Bulk Issue
export const BULK_ISSUE_HOSPITALS_LIST = `${API_BASE_URL_IPD}bulk_issue_hospitals_list`;
export const BULK_ISSUE_TO_HOSPITAL = `${API_BASE_URL_IPD}bulk_issue_to_hospital`;
export const BULK_ISSUED_LIST = `${API_BASE_URL_IPD}bulk_issued_list`;

export const ROW_STATUS_UPDATE = `${API_BASE_URL_IPD}update_row_status`;

export const GET_PATIENT_ADMIT_ORDERS = (params) => `${API_BASE_URL_IPD}get_patient_admit_orders/${params.patient_id}/${params.encounter_id}`;
export const GET_AKNOWLEDGE_ADMIT_ORDERS = (params) => `${API_BASE_URL_IPD}get_acknowledge_admit_orders/${params.patient_id}/${params.encounter_id}`;
export const ACKNOWLEDGE_ADMIT_ORDERS = `${API_BASE_URL_IPD}acknowledge_admit_orders`;
export const GET_PATIENT_ADMITTING_PRACTITIONER_ORDERS = `${API_BASE_URL_IPD}get_patient_admittting_orders`;
export const GET_PATIENT_AKNOWLEDGE_ADMIT_ORDERS = `${API_BASE_URL_IPD}get_acknowledge_patient_admit_orders`;

// IPD NURSE HANDOVER
export const NURSE_HANDOVER_SAVE_UPDATE = `${API_BASE_URL_IPD}handover/nurse/save`;
export const NURSE_HANDOVER_LIST = `${API_BASE_URL_IPD}handover/nurse/list`;

//History
export const PATIENT_HISTORY_MODULES = `${API_BASE_URL_IPD}patient-history-module`;
export const PATIENT_HISTORY = `${API_BASE_URL_IPD}patient-history`;
export const PATIENT_HISTORY_MODAL = `${API_BASE_URL_IPD}patient-history/modal-list`;
export const PATIENT_HISTORY_TEST_RESULT_GRAPH = `${API_BASE_URL_IPD}patient-history-test-result/graph`;
export const HISTORY_VITALS_GETALL = (params) => `${API_BASE_URL_IPD}patient-history/charting/getAll/${params.patient_id}/${params.date}/vitals`;
export const PATIENT_HISTORY_SOCIALHX_LIST = `${API_BASE_URL_IPD}get-patient-history-socialHx`;

//Active Complaint
export const ADD_COMPLAINT = (params) => `${API_BASE_URL_IPD}complaint-store/${params.reference_type}/${params.encounter_id}/${params.patient_id}`;
export const FETCH_COMPLAINT = (params) => `${API_BASE_URL_IPD}complaint/${params.reference_type}/${params.encounter_id}`;
export const FETCH_OP_DETAILS = `${API_BASE_URL_IPD}op-details`;

//Add Vitals
export const IPD_VITAL_STORE = `${API_BASE_URL_IPD}vitals/store`;
export const ADD_NOK_REMARKS = `${API_BASE_URL_IPD}nok/remarks/store`;
export const GET_NOK_REMARKS = `${API_BASE_URL_IPD}get/nok/remarks`;


export const IPD_VITAL_GET = `${API_BASE_URL_IPD}vitals/getAll`;

//Event List
export const IPD_EVENTS = `${API_BASE_URL_IPD}event/list`;
export const HOMECARE_PATIENTLIST = (params) => `${API_BASE_URL}homecare/patient-list?booking_status=${params.booking_status}&date=${params.date}&hospital_id=${params.hospital_id}&page=${params.page}&per_page=${params.per_page}`;
export const HOMECARE_VITALALERTLIST = (params) => `${API_BASE_URL}homecare/doctor/patient-vital-alerts?doctor_id=${params.doctor_id}&hospital_id=${params.hospital_id}`;
export const HOMECARE_PATIENTALERTLIST = (params) => `${API_BASE_URL}homecare/doctor/alerts?doctor_id=${params.doctor_id}`;
export const HOMECARE_DETAIL = (params) => `${API_BASE_URL}homecare/patient-details?booking_id=${params.booking_id}&is_called_patient=${params.is_called_patient}`;
//export const HOMECARE_STORE_TEST_NOTES = `${API_BASE_URL}homecare/patient-details/store-test-notes`;
export const PROGRESSNOTES = (params) => `${API_BASE_URL}homecare/patient-details/progress-notes?booking_id=${params.booking_id}`;
export const PROGRESSNOTESACCORDIAN = (params) => `${API_BASE_URL}homecare/patient-details/packages?booking_id=${params.booking_id}&hospital_id=${params.hospital_id}`;
export const HOMECARE_STORE_TEST_NOTES = `${API_BASE_URL}homecare/patient-details/store-notes`;
export const HOMECARE_SEND_PRESCRIPTION = (params) => `${API_BASE_URL}homecare/patient-details/send-prescription`;
export const HOMECARE_CONSULT_ALERT = (params) => `${API_BASE_URL}homecare/patient/booking-alerts?booking_id=${params.booking_id}`;
export const HOMECARE_SAVE_ALERT = (params) => `${API_BASE_URL}homecare/doctor/store-patient-alerts`;
export const HOMECARE_SAVE_VITAL_ALERT = (params) => `${API_BASE_URL}homecare/doctor/store-patient-vital-alerts`;
export const HOMECAREPASTVISIT = (params) => `${API_BASE_URL}homecare/patient/past-prescriptions?patient_id=${params.patient_id}&is_homecare=1&hospital_id=${params.hospital_id}&page=${params.page}`;
export const HOMECARE_STORE_CURRENT_MEDICINE = (params) => `${API_BASE_URL}homecare/patient/current-medicines/store`;
export const HOMECARE_CURRENT_MEDICINE_GET = (params) => `${API_BASE_URL}homecare/patient/current-medicines/get?patient_id=${params.patient_id}&booking_id=${params.booking_id}`;
export const HOMECARE_CALL_RECORD_RATING = `${API_BASE_URL}doctors/homecare-call`;
export const HOMECARE_TEST_NOTES = (params) => `${API_BASE_URL}homecare/patient/test-notes?booking_id=${params.booking_id}&page=${params.page}`;
export const HOMECARE_SAVE_INTERNAL_NOTES = `${API_BASE_URL}homecare/patient/internal-notes/store`;
export const HOMECARE_GET_INTERNAL_NOTES = (params) => `${API_BASE_URL}homecare/patient/internal-notes/get?booking_id=${params.booking_id}&patient_id=${params.patient_id}`;
export const HOMECARE_SEND_CASE_SUMMARY = `${API_BASE_URL}homecare/send-case-summary`;
export const HOMECARE_DRAFT_CASE_SUMMARY = `${API_BASE_URL}homecare/patient/case-summary/store`;
export const HOMECARE_GET_CASE_SUMMARY = (params) => `${API_BASE_URL}homecare/patient/case-summary/get?booking_id=${params.booking_id}&patient_id=${params.patient_id}`;
export const HOMECARE_CREATE_SLOT = `${API_BASE_URL}calendar/create-slot`;

export const DOSE_RULE = `${API_BASE_URL}dose/rule`;
export const LAST_VITAL_ADDED_DATA = (params) => `${API_BASE_URL}last_vital_added?patient_id=${params.patient_id}`;
//vitals filter api's
export const VITALS_FILTER_SEQUENCING_LIST = (params) => `${API_BASE_URL_IPD}vitals-filter-sequencing/list/${params.doctor_id}`;
export const VITALS_FILTER_SEQUENCING_SAVE = `${API_BASE_URL_IPD}vitals-filter-sequencing/save`;
export const VISITS_BY_DOCTOR = (params) =>`${API_BASE_URL_IPD}visits/list/${params.doctor_id}`;

//mews configuration
export const VITALS_CONFIGURATION_SAVE = `${API_BASE_URL_IPD}save-vitals-config`;
export const GET_MEWS_VITALS_DETAILS = (params) =>`${API_BASE_URL_IPD}get-vitals-config/${params.doctor_id}/${params.facility_id}`;

//Vitals 
export const GET_VITALS_GROUPS = `${API_BASE_URL_IPD}get-vitals-groups`;
export const GET_VITALS_LIST = `${API_BASE_URL_IPD}get-vitals-list`;
export const CREATE_VITALS_MASTER = `${API_BASE_URL_IPD}create-vital-master`;
export const CREATE_VITALS_TEST_MAPPING = `${API_BASE_URL_IPD}create-vital-test-mapping`;



/* Nursing care plans */
export const NCP_CREATE_PLAN = `plans/create`;
export const NCP_PLANS_LIST = `plans`;
export const NURSING_CREATE_DIAGNOSIS = `nursing/diagnosis/create`;
export const NURSING_DIAGNOSIS_LIST = `nursing/diagnosis`;
export const NURSING_DIAGNOSIS_PLANS_LIST = `nursing/diagnosis/plans`;
export const NURSING_SEVERITY_LIST = `nursing/diagnosis/severities`;
export const NURSING_CREATE_GOAL = `nursing/goals/create`;
export const NURSING_GOAL_LIST = `nursing/goals`;
export const NURSING_CREATE_INTERVENTION = `nursing/interventions/create`;
export const NURSING_INTERVENTION_LIST = `nursing/interventions`;
export const NURSING_CREATE_EVALUATIONS = `nursing/evaluations/create`;
export const NURSING_EVALUATIONS_LIST = `nursing/evaluations`;
export const NURSING_CREATE_NCP_GOALS = `nursing/ncp-goals/create`;
export const NURSING_NCP_GOALS_LIST = `nursing/ncp-goals`;
export const NURSING_CREATE_INTERVENTION_GOALS = `nursing/goal-interventions/create`;
export const NURSING_INTERVENTION_GOALS_LIST = `nursing/goal-interventions`;
export const NURSING_CREATE_OUTCOMES = `nursing/outcomes/create`;
export const NURSING_OUTCOMES_LIST = `nursing/outcomes`;
export const VITAL_SIGN_LIST = `vitals/list`;
export const PATIENT_ADD_CARE_PLAN = `nursing/patient/add-care-plan`;
export const PATIENT_CARE_PLANS = `nursing/patients/care-plans`;
export const DELETE_PATIENT_CARE_PLAN = `nursing/delete/care-plan`;
export const INITIATE_CARE_PLAN = `nursing/initiate/care-plan`;
export const PATIENT_CARE_PLAN_INFO = `nursing/patient-care-plan`;
export const ALL_PATIENT_CARE_PLANS_INFO =`nursing/all-patient-care-plan`;  
export const IS_AUTHORIZE_CARE_PLAN =`nursing/patient/is-authorize`;           
export const NURSING_TIMELINE_CARE_PLAN =`nursing/patient/nursing_careplan_timeline`;           


export const PATIENT_ACTIVE_CARE_PLANS = `nursing/patient/active-care-plans`;
export const SUBMIT_INTERVENTION_TASK = `nursing/submit/intervention-task`;
export const CTA_CARE_PLAN = `nursing/cta/care-plan`;
export const REASONS_LIST = `/RemarksMaster/fillReason`;
export const DISCONTINUE_INTERVENTION = `nursing/discontinue/intervention`;
export const EVALUATIONS_PARAMS = `nursing/evaluations/params`;
export const RECORD_ADVERSE_EVENT = `${API_BASE_URL_IPD}record-adverse-event`;
export const LIST_ADVERSE_EVENT = `${API_BASE_URL_IPD}list-adverse-event`;


// CSSD MODULE
export const STORE_EQUIPMENTS_MASTER = `${API_BASE_URL_IPD}cssd/store-equipment-master`;
export const MASTER_EQUIPMENTS_LIST  = (params) =>  `${API_BASE_URL_IPD}cssd/get-equipment-master-list?page=${params.page}&record_per_page=${params.record_per_page}&facilityId=${params.facilityId}&enterpriseId=${params.enterpriseId}&active=${params.active}`;
export const GET_STERILIZATION_PROCESS_LIST = `${API_BASE_URL_IPD}cssd/get-sterilization_process`;
export const UPDATE_EQUIPMENTS_MASTER = `${API_BASE_URL_IPD}cssd/update-equipment-master`;
export const FIND_ALL_UNITS =`${API_BASE_URL_IPD}cssd/findAllUnits`;
export const FIND_EQUIPMENTS_ENTITIES =`${API_BASE_URL_IPD}cssd/find-equipment-entities`;
export const SAVE_EQUIPMENT_SETUP =`${API_BASE_URL_IPD}cssd/save-equipment-setup`;
export const GET_EQUIPMENT_SETUP = (params) =>  `${API_BASE_URL_IPD}cssd/get-equipment-setup?id=${params.id}&facilityId=${params.facilityId}&enterpriseId=${params.enterpriseId}`;
export const SAVE_EQUIPMENT_FACILITYWISE = `${API_BASE_URL_IPD}cssd/save-equipment-facilitywise`;
export const GET_EQUIPMENT_FACILITYWISE = (params) =>  `${API_BASE_URL_IPD}cssd/get-equipment-facilitywise?id=${params.id}&enterprise_id=${params.enterprise_id}`;
export const SAVE_ITEM_STERIZILATION_PROCESS =`${API_BASE_URL_IPD}cssd/save-item-sterilization-process`;
export const GET_ITEM_STERIZILATION_PROCESS = (params) =>  `${API_BASE_URL_IPD}cssd/get-item-sterilization-process?item_id=${params.item_id}&facilityId=${params.facilityId}&enterpriseId=${params.enterpriseId}`;
export const GET_ITEM_STERIZILATION_PROCESS_BY_ID = (params) =>  `${API_BASE_URL_IPD}cssd/get-item-sterilization-process-by-id?item_id=${params.item_id}&facilityId=${params.facilityId}&enterpriseId=${params.enterpriseId}`;
export const GET_SAVED_KITS = (params) =>  `${API_BASE_URL_IPD}cssd/get-saved-kits?kit_name=${params.kit_name}&facilityId=${params.facilityId}&enterpriseId=${params.enterpriseId}`;
export const GET_SAVED_KIT_BY_ID = (params) =>  `${API_BASE_URL_IPD}cssd/get-saved-kit-by-id?kit_id=${params.kit_id}`;
export const SAVE_KIT_DATA =`${API_BASE_URL_IPD}cssd/save-kit`;
export const SAVE_STERILIZATION_REQUEST =`${API_BASE_URL_IPD}cssd/save-equipment-sterilization-request`;
export const SEARCH_STERILIZATION_REQUEST = (params) =>  `${API_BASE_URL_IPD}cssd/search-sterilization-request?search=${params.search}&request_type=${params.request_type}&facilityId=${params.facilityId}&enterpriseId=${params.enterpriseId}`;
export const GETITEM_BY_STERILIZATION_STATUS = (params) =>  `${API_BASE_URL_IPD}cssd/getItems-by-sterilizationStatus?sterio_id=${params.sterio_id}&facilityId=${params.facilityId}&enterpriseId=${params.enterpriseId}`;
export const GET_ALL_STERLIZATION_REQUEST = (params) =>  `${API_BASE_URL_IPD}cssd/all-sterilization-request?page=${params.page}&facilityId=${params.facilityId}&enterpriseId=${params.enterpriseId}`;
export const FILTER_STERILIZATION_REQUEST =`${API_BASE_URL_IPD}cssd/filter-sterilization-request`;
export const UPDATE_STERILIZATION_REQUEST_STATUS =`${API_BASE_URL_IPD}cssd/update-request-status`;
export const SAVE_EQUIPMENT_STERILIZATION =`${API_BASE_URL_IPD}cssd/save-equipment-sterlization`;
export const GET_EQUIPMENT_STERILIZATION = `${API_BASE_URL_IPD}cssd/get-equipment-sterlization`;
export const GET_EQUIPMENT_BOWIE_STERILIZATION = `${API_BASE_URL_IPD}cssd/get-equipment-bowie-sterlization`;
export const FILTER_EQUIPMENT_STERILIZATION = `${API_BASE_URL_IPD}cssd/filter-all-equipment-sterlization`;
export const FILTER_BOWIE_STERILIZATION = `${API_BASE_URL_IPD}cssd/filter-all-bowie-sterlization`;
export const CHECK_BOWIE_DICKTEST_STATUS = `${API_BASE_URL_IPD}cssd/check-bowie-dick-test-status`;
export const GET_EQUIPMENT_MASTER_BY_FACILITY = `${API_BASE_URL_IPD}cssd/get-equipment-master-byfacility-list`;
export const SAVE_RETURN_REQUEST = `${API_BASE_URL_IPD}cssd/save-equipment-return-request`
export const UPDATE_RECALL_BATCH_STATUS = `${API_BASE_URL_IPD}cssd/recall-batch-status`
export const GET_HIS_MASTER_REASON = `${API_BASE_URL_IPD}cssd/get-his-master-reasons`

// diagnosis-keyword
export const SAVE_DIAGNOSIS_KEYWORD = `${API_BASE_URL_IPD}store/diagnosis-keyword`
export const FETCH_DIAGNOSIS_KEYWORD = `${API_BASE_URL_IPD}all/diagnosis-keyword`
export const SINGLE_DIAGNOSIS_KEYWORD = `${API_BASE_URL_IPD}single/diagnosis-keyword`
export const DELETE_DIAGNOSIS_KEYWORD = `${API_BASE_URL_IPD}delete/diagnosis-keyword`
// Pain Assessment Api
export const PAIN_ASSESSMENT_GET = `${API_BASE_URL_IPD}pain-assessment/all`
export const PAIN_ASSESSMENT_STORE = `${API_BASE_URL_IPD}pain-assessment/save`
export const INTERVENTION_COMPLETE = `${API_BASE_URL_IPD}pain-assessment/intervention-complete`
export const INTERVENTION_GRAPH_INFO = `${API_BASE_URL_IPD}pain-assessment/sliding-scale-graph-info`
export const PAIN_ASSESSMENT_GET_DETAILS = `${API_BASE_URL_IPD}pain-assessment/get-details`
export const PAIN_ASSESSMENT_DELETE_DETAILS = `${API_BASE_URL_IPD}pain-assessment/delete-details`
export const PAIN_ASSESSMENT_TIMELINE_DETAILS = `${API_BASE_URL_IPD}pain-assessment/get-pain-assessment-timeline`

export const PATIENT_DISCHARGE_SUMMARY_LIST_EXTERNAL = (params) =>
`${API_BASE_URL_IPD}discharge_summary_list_external?data=${params.patient_id}&page=${params.pagination}&startdate=${params.startdate}&enddate=${params.enddate}&patient_name=${params.patient_name}`;
export const ALL_PRESCRIPTIONS_EXTERNAL = `${API_BASE_URL_IPD}past-visit-others`;



/* || REACT COMMON FUNCTIONS & VARIABLES */
export const HANDLEVALIDANTMESSAGES = {
    required: 'Required!',
    types: {
        number: 'Not a valid number!',
    },
    number: {
        range: 'Must be between ${min} and ${max}',
        min: 'Must not be less than ${min}',
        max: 'Must not be greater than ${max}'
    },
};
export const HANDLEVALIDANTMESSAGESPATIENTAGE = {
    required: 'Required!',
    types: {
        number: 'Not a valid number!',
    },
    number: {
        range: 'Duration cannot be greater than patient\'s age',
    },
};
export const TAB_NAMES = ['worklist', 'completed', 'pending', 'homecare'];
export const PASTPRESCRIPTION_TAB_NAMES = ['homecare', 'vcopd'];
export const MEDICATION_ON = ['No', 'Yes'];
export const DURATION_TYPE = ['days', 'weeks', 'months', 'years'];
export const DURATION_TYPE_OBJECT = { 'days': 1, 'weeks': 7, 'months': 30, 'years': 365 };
export const DURATION_TYPE_OBJECT_REVERSE = { 1: 'Days', 7: 'Weeks', 30: 'Months', 365: 'Years' };
export const DURATION_TYPE_OBJECT_REVERSE_SINGULAR = { 1: 'Day', 7: 'Week', 30: 'Month', 365: 'Year' };
export const DURATION_TYPE_SMALL = ['d', 'w', 'm', 'y'];
export const DURATION_TYPE_SINGULAR = ['day', 'week', 'month', 'year'];
export const MONTHS = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const VITAL_ARRAY = ['V001', 'V002', 'V003', 'V004', 'V005', 'V007', 'V008', 'V009', 'V010', 'V011'];
export const INFORMED_BY = ['Observed by Clinician', 'Informed by Patient'];
export const PATIENT_STATUS = { 'Completed': 'patientArrived', 'Arrived': 'patientArrived', 'Missed': 'patientNoShow', 'Confirmed': 'patientConfirmed' };
export const GETVITAL_RANGE_CLASS = (value, range) => { if (value == '-') { return ''; } var $vitalRange = ''; if (value >= range.normal.min && value <= range.normal.max) { $vitalRange = 'text-success'; } if ((value > range.critical.min && value < range.normal.min) || (value > range.normal.max && value < range.critical.max)) { $vitalRange = 'text-warning'; } if ((range.critical.min != null && value <= range.critical.min) || (range.critical.max != null && value >= range.critical.max)) { $vitalRange = 'text-danger'; } return $vitalRange; }
export const ALLERGY_INTENSITY = [{ 'name': 'Low', 'image': 'allergies-primary.png', 'class': 'icon-severity-low' }, { 'name': 'Moderate', 'image': 'allergies-warning.png', 'class': 'icon-severity-medium' }, { 'name': 'High', 'image': 'allergies-danger.png', 'class': 'icon-severity-high' }];
export const DRUG_URGENCY = {
    1: 'STAT',
    2: 'Urgent',
    3: 'Routine'
};
export const SOCIAL_ROUTE = {
    1: 'Oral',
    2: 'IV',
    3: 'Others',
};
export const DRUG_INSTRUCTION = {
    1: 'After meals',
    2: 'Before meals',
    3: 'Empty stomach',
    4: 'As directed'
};
export const DRUG_FREQUENCY = {
    1: 'Daily',
    2: 'Specific Days',
    3: 'PRN'
}
export const DOSAGE_VALUE = {
    1: 1 / 2,
    2: 1,
    3: 2,
    4: 3,
    5: 4,
    6: 5
}

/********************** Anc Constant Values ***************************/

export const CONCEPTION_OPTIONS = [
  { val: '1', label: 'Natural' },
  { val: '2', label: 'IVF' },
  { val: '3', label: 'IUI' }
];

export const PREGNANCY_OPTIONS = [
  { val: '1', label: 'Single' },
  { val: '2', label: 'Multiple' },
  { val: '3', label: 'Ectopic' }
];

export const DELIVERY_OPTIONS = [
  { val: '1', label: 'Normal' },
  { val: '2', label: 'LSCS' },
  { val: '3', label: 'Forceps' },
  { val: '4', label: 'Water Birthing' }
];

export const OUTCOME_OPTIONS = [
  { val: '1', label: 'Live Term' },
  { val: '2', label: 'Live Pre-Term' },
  { val: '3', label: 'Still born Term' },
  { val: '4', label: 'Still born Pre-Term' },
  { val: '5', label: 'Spontaneous Abortion' },
  { val: '6', label: 'MTP' }
];

export const PLACE_OF_DELIVERY_OPTIONS = [
  { val: '1', label: 'Hospital' },
  { val: '2', label: 'Home' },
  { val: '3', label: 'PHC' },
  { val: '4', label: 'Others' }
];

//Physical examination
export const FETAL_MOVEMENT = {
  1: "Present",
  2: "Absent",
};

export const PRESENTATION = {
  1: "Cephalic",
  2: "Breech",
  3: "Vertex",
  4: "Shoulder",
  5: "Compound",
};

export const RELATIONSHIP_TO_PP_BRIM = {
  1: "1/5",
  2: "2/5",
  3: "3/5",
  4: "4/5",
  5: "5/5",
};

export const CSSD_STATUS = {
    1: "Requested",
    2: "Rejected",
    3: "Acknowledged",
    4: "Packaging Done",
    5: "Sterilization In Process",
    6: "Sterilization Completed",
    7: "Issued to Department",
    8: "Received",
    9: "Recalled"
}

export const DRUG_ROUTE = {
    1: 'Oral ',
    2: 'Eye ',
    3: 'Ear ',
    4: 'Nasal ',
    5: 'Inhalation ',
    6: 'Skin ',
    7: 'Rectal ',
    8: 'Vaginal ',
    9: 'Intramascular Injection',
    10: 'Sublingual ',
    11: 'Intra-venous Injection',
    12: 'Sub-cutanious Injection',
    13: 'Intra-venous Infusion'
}
export const ALLERGY_INTENSITY_IC = {
    0: 'icon-severity-low',
    1: 'icon-severity-medium',
    2: 'icon-severity-high',
}
export const ALLERGY_INFORMED_BY = {
    0: 'Observed by Clinician',
    1: 'Informed by Patient',
}
export const GENDER = {
    0: 'Male',
    1: 'Female',
    2: 'Transgender',
}
export const BLOOD_GROUP = {
    0: 'A+',
    1: 'B+',
    2: 'AB+',
    3: 'O+',
    4: 'O-',
    5: 'A-',
    6: 'B-',
    7: 'AB-',
}

export const SORTING_COMPARE = (key, order) => {
    return function (a, b) {
        if (order === 'asc') {
            if (a[key] < b[key]) return -1;
            if (a[key] > b[key]) return 1;
        } else {
            if (b[key] < a[key]) return -1;
            if (b[key] > a[key]) return 1;
        }
        return 0;
    };
}

export const ALLERGY_TAB_STATUS = ['DRUGS', 'FOOD', 'OTHERS'];
export const ALLERGY_TAB_TYPE = { 'DRUGS': 0, 'FOOD': 1, 'OTHERS': 2 };
export const ISD_CODES = [{ "isd_code": 1 }, { "isd_code": 7 }, { "isd_code": 20 }, { "isd_code": 27 }, { "isd_code": 30 }, { "isd_code": 31 }, { "isd_code": 32 }, { "isd_code": 33 }, { "isd_code": 34 }, { "isd_code": 36 }, { "isd_code": 38 }, { "isd_code": 39 }, { "isd_code": 40 }, { "isd_code": 41 }, { "isd_code": 43 }, { "isd_code": 44 }, { "isd_code": 45 }, { "isd_code": 46 }, { "isd_code": 47 }, { "isd_code": 48 }, { "isd_code": 49 }, { "isd_code": 51 }, { "isd_code": 52 }, { "isd_code": 53 }, { "isd_code": 54 }, { "isd_code": 55 }, { "isd_code": 56 }, { "isd_code": 57 }, { "isd_code": 58 }, { "isd_code": 60 }, { "isd_code": 61 }, { "isd_code": 62 }, { "isd_code": 63 }, { "isd_code": 64 }, { "isd_code": 65 }, { "isd_code": 66 }, { "isd_code": 70 }, { "isd_code": 81 }, { "isd_code": 82 }, { "isd_code": 84 }, { "isd_code": 86 }, { "isd_code": 90 }, { "isd_code": 91 }, { "isd_code": 92 }, { "isd_code": 93 }, { "isd_code": 94 }, { "isd_code": 95 }, { "isd_code": 98 }, { "isd_code": 211 }, { "isd_code": 212 }, { "isd_code": 213 }, { "isd_code": 216 }, { "isd_code": 218 }, { "isd_code": 220 }, { "isd_code": 221 }, { "isd_code": 222 }, { "isd_code": 223 }, { "isd_code": 224 }, { "isd_code": 225 }, { "isd_code": 226 }, { "isd_code": 227 }, { "isd_code": 228 }, { "isd_code": 229 }, { "isd_code": 230 }, { "isd_code": 231 }, { "isd_code": 232 }, { "isd_code": 233 }, { "isd_code": 234 }, { "isd_code": 235 }, { "isd_code": 236 }, { "isd_code": 237 }, { "isd_code": 238 }, { "isd_code": 239 }, { "isd_code": 240 }, { "isd_code": 241 }, { "isd_code": 242 }, { "isd_code": 244 }, { "isd_code": 245 }, { "isd_code": 246 }, { "isd_code": 248 }, { "isd_code": 249 }, { "isd_code": 250 }, { "isd_code": 251 }, { "isd_code": 252 }, { "isd_code": 253 }, { "isd_code": 254 }, { "isd_code": 255 }, { "isd_code": 256 }, { "isd_code": 257 }, { "isd_code": 258 }, { "isd_code": 260 }, { "isd_code": 261 }, { "isd_code": 262 }, { "isd_code": 263 }, { "isd_code": 264 }, { "isd_code": 265 }, { "isd_code": 266 }, { "isd_code": 267 }, { "isd_code": 268 }, { "isd_code": 269 }, { "isd_code": 290 }, { "isd_code": 291 }, { "isd_code": 297 }, { "isd_code": 298 }, { "isd_code": 299 }, { "isd_code": 350 }, { "isd_code": 351 }, { "isd_code": 352 }, { "isd_code": 353 }, { "isd_code": 354 }, { "isd_code": 355 }, { "isd_code": 356 }, { "isd_code": 357 }, { "isd_code": 358 }, { "isd_code": 359 }, { "isd_code": 370 }, { "isd_code": 371 }, { "isd_code": 372 }, { "isd_code": 373 }, { "isd_code": 374 }, { "isd_code": 375 }, { "isd_code": 376 }, { "isd_code": 377 }, { "isd_code": 378 }, { "isd_code": 380 }, { "isd_code": 381 }, { "isd_code": 385 }, { "isd_code": 386 }, { "isd_code": 387 }, { "isd_code": 389 }, { "isd_code": 420 }, { "isd_code": 421 }, { "isd_code": 423 }, { "isd_code": 500 }, { "isd_code": 501 }, { "isd_code": 502 }, { "isd_code": 503 }, { "isd_code": 504 }, { "isd_code": 505 }, { "isd_code": 506 }, { "isd_code": 507 }, { "isd_code": 508 }, { "isd_code": 509 }, { "isd_code": 590 }, { "isd_code": 591 }, { "isd_code": 592 }, { "isd_code": 593 }, { "isd_code": 594 }, { "isd_code": 595 }, { "isd_code": 596 }, { "isd_code": 597 }, { "isd_code": 598 }, { "isd_code": 599 }, { "isd_code": 670 }, { "isd_code": 672 }, { "isd_code": 673 }, { "isd_code": 674 }, { "isd_code": 675 }, { "isd_code": 676 }, { "isd_code": 677 }, { "isd_code": 678 }, { "isd_code": 679 }, { "isd_code": 680 }, { "isd_code": 681 }, { "isd_code": 682 }, { "isd_code": 683 }, { "isd_code": 684 }, { "isd_code": 686 }, { "isd_code": 687 }, { "isd_code": 688 }, { "isd_code": 689 }, { "isd_code": 690 }, { "isd_code": 691 }, { "isd_code": 692 }, { "isd_code": 850 }, { "isd_code": 852 }, { "isd_code": 853 }, { "isd_code": 855 }, { "isd_code": 856 }, { "isd_code": 880 }, { "isd_code": 886 }, { "isd_code": 960 }, { "isd_code": 961 }, { "isd_code": 962 }, { "isd_code": 963 }, { "isd_code": 964 }, { "isd_code": 965 }, { "isd_code": 966 }, { "isd_code": 967 }, { "isd_code": 968 }, { "isd_code": 970 }, { "isd_code": 971 }, { "isd_code": 972 }, { "isd_code": 973 }, { "isd_code": 974 }, { "isd_code": 975 }, { "isd_code": 976 }, { "isd_code": 977 }, { "isd_code": 992 }, { "isd_code": 994 }, { "isd_code": 995 }, { "isd_code": 996 }, { "isd_code": 998 }, { "isd_code": 1147 }, { "isd_code": 1242 }, { "isd_code": 1246 }, { "isd_code": 1264 }, { "isd_code": 1268 }, { "isd_code": 1284 }, { "isd_code": 1340 }, { "isd_code": 1345 }, { "isd_code": 1441 }, { "isd_code": 1473 }, { "isd_code": 1649 }, { "isd_code": 1664 }, { "isd_code": 1670 }, { "isd_code": 1671 }, { "isd_code": 1684 }, { "isd_code": 1758 }, { "isd_code": 1767 }, { "isd_code": 1784 }, { "isd_code": 1787 }, { "isd_code": 1809 }, { "isd_code": 1868 }, { "isd_code": 1869 }, { "isd_code": 1876 }, { "isd_code": 7370 }];
export const SEPARATEUPLOADEDDOCSNEW = docs => { let uploadedFiles = []; if (docs && docs.length > 0) { docs.forEach(value => { const fileExt = value.file.split(".").slice(-1)[0]; if (fileExt === "jpg" || fileExt === "jpeg" || fileExt === "JPG" || fileExt === "JPEG" || fileExt === "gif" || fileExt === "png" || fileExt === "PNG") uploadedFiles.push({ 'src': UPDATEFILEURL(value.file), 'type': 'img' }); else if (fileExt === "pdf") uploadedFiles.push({ 'src': UPDATEFILEURL(value.file), 'type': 'pdf' }); }); } return [...uploadedFiles] };
export const SEPARATEUPLOADEDDOCS = docs => { let uploadedImages = []; let uploadedDocs = []; if (docs && docs.length > 0) { docs.forEach(value => { const fileExt = value.file.split(".").slice(-1)[0]; if (fileExt === "jpg" || fileExt === "jpeg" || fileExt === "png") uploadedImages.push(UPDATEFILEURL(value.file)); else if (fileExt === "pdf") uploadedDocs.push(UPDATEFILEURL(value.file)); }); } return { fileImg: uploadedImages, fileDoc: uploadedDocs } };
export const UPDATEFILEURL = url => { return url.replace("//20", "/20"); };
export const IMAGE_EXT = img => img.split('.').pop();
export const IS_URL = url => url.includes('http');
export const BMI_CALCULATE = (V001, V002) => { let $weight = parseFloat(V002); let $height = parseFloat(V001); $height = $height * 0.01; let $bmi = $weight / ($height * $height); if (!isNaN($bmi)) { return $bmi.toFixed(1) } else { return ''; } }
export const HANDLETEXTAREAAUTOHEIGHT = (textarea, clear = false) => {
    const Elem = document.querySelectorAll('.' + textarea);
    if (!clear) {
        Elem.forEach((el) => { el.style.height = el.scrollHeight + "px"; });
    } else {
        Elem.forEach((el) => { el.style.height = "40px"; });
    }
}
export const GETGENDER = gender => { if (gender === "Male") return "M"; else if (gender === "Female") return "F"; else if (gender === "Other") return "O"; else return ""; };
export const UHID = uhid => { if (uhid !== "" && uhid !== "--" && uhid !== null) { return uhid; } return ""; }
export const TEMPERATURE_TYPE_VALIDATE_FUNCTION = (temprature_type) => temprature_type ? "C" : "F";
export const HANDLE_PATIENT_VITALS_COLORS = (value) => { switch (value) { case "Critical": { return "text-vital-critical"; } case "Abnormal": { return "text-vital-abnormal"; } case "Normal": { return "text-vital-normal"; } } };
export const HANDLEIMAGEROTATE = elem => { const targetName = elem.currentTarget; const imgElem = document.querySelector('.modal-imgdocs figure'); if (targetName.getAttribute("name") === "rotate-left") { if (imgElem.dataset.rotate === "" || imgElem.dataset.rotate === undefined) { $(imgElem).css('transform', 'rotate(-90deg)'); imgElem.dataset.rotate = -90; } else { const currentVal = imgElem.dataset.rotate; $(imgElem).css('transform', `rotate(${currentVal - 90}deg)`); imgElem.dataset.rotate = (currentVal - 90); } } else { if (imgElem.dataset.rotate === "" || imgElem.dataset.rotate === undefined) { $(imgElem).css('transform', 'rotate(90deg)'); imgElem.dataset.rotate = 90; } else { const currentVal = imgElem.dataset.rotate; $(imgElem).css('transform', `rotate(${+currentVal + 90}deg)`); imgElem.dataset.rotate = (+currentVal + 90); } } };
export const GET_VITALS_RANGE_CLASS = (value, range) => {
    if (value == '-') return '';
    let vitalRange = '';
    //normal range
    if (value >= range.normal.min && value <= range.normal.max)
        vitalRange = 'text-success';

    //abnormal range
    if (
        (value > range.critical.min && value < range.normal.min) ||
        (value > range.normal.max && value < range.critical.max)
    )
        vitalRange = 'text-warning';

    //critical range
    if ((range.critical.min != null && value <= range.critical.min) || (range.critical.max != null && value >= range.critical.max))
        vitalRange = 'text-danger';

    return vitalRange;
}

export const MEWS_RANGE_CLASS = (mewsScore , escalationPathway) => {
    let mewsInfo = {};
    let mewsClass = "text-success";
    if (mewsScore >= 0 && escalationPathway && escalationPathway.length > 0) {
      for (let index = 0; index < escalationPathway.length; index++) {
        const esc = escalationPathway[index];
        if ((mewsScore >= esc.from_ews && mewsScore <= esc.to_ews)) {
          mewsInfo = esc;
          break;
        }
      }
    }
    if(mewsInfo.trigger_check && mewsInfo.trigger_check == "Y"){
        mewsClass = "text-danger"
    }
    return mewsClass;
}

export const GOBACK = (event, props) => { event.preventDefault(); props.history.goBack() }
export const HC_GOBACK = (event, props, state) => {
    event.preventDefault();
    props.history.push({
        pathname: `/patient/homecare/details/${state.hospital_id}/${state.patient_id}/${REFERENCE_TYPE}/${state.reference_id || state.booking_id}`,
        state: { isCallToday: 0 },
    });
}

export const ISALLOWEDITSOAP = (pres_modification, allow_hours, completed_time, type) => {
    if (!completed_time)
        return true;
    completed_time = completed_time.replace("Z", "");
    var allowed_time = moment(completed_time).add(timezoneOffsetMinutes, 'minutes').add(allow_hours, 'hours');
    var current_time = moment();
    var diff = current_time.diff(allowed_time, 'seconds');
    if (pres_modification == 'no')
        return false;
    else if (diff < 0) {
        if (type == 'patient-queue')
            return pres_modification == 'allow' || pres_modification == 'addendum' ? true : false;
        else if (type == 'button')
            return pres_modification == 'allow' ? true : false;
    }
    else
        return false;
}

/* || REACT COMPONENTS */

export const LOADER = (<div className="spinner"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div>);
export const LOADER_RED = (<div className="spinner red"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div>);
export const LOADER_BLACK = (<div className="spinner black"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div>);

/** Environment variables */

export const APPS_USERTYPES = {
    "woodlands": {
        doctor: 1,
        nurse: 2
    },
    "mhvcmarketplace": {
        doctor: 3,
        nurse: 2
    }
};
export const APP_DEFAULT_VALUES = {
    "woodlands": {
        maximum_medicines_allowed: 8,
        age: 5,
        sessionTimeout: 30,
    },
    "mhvcmarketplace": {
        maximum_medicines_allowed: 10,
        age: 5,
        sessionTimeout: 30,
    }
}
export const USERTYPES = APPS_USERTYPES[MYHC_APPTYPE];
export const HOSPITALDEFAULTS = APP_DEFAULT_VALUES[MYHC_APPTYPE];
export const REFERENCE_TYPE = 0;
export const HOMECARE_REFERENCE_TYPE = 2;
export const DEFAULT_VC_DRIVER = 1; // 1 is for Quickblox

// IPD Order set constants
export const HOSPITALDEFAULTS_IPD = APP_DEFAULT_VALUES[MYHC_APPTYPE];
export const USERTYPES_IPD = APPS_USERTYPES[MYHC_APPTYPE];

export const SPEECH_SUBSCRIPTION_ID = process.env.SPEECH_SUBSCRIPTION_ID;
export const SPEECH_SUBSCRIPTION_AREA = process.env.SPEECH_SUBSCRIPTION_AREA;
export const SPEECH_ENDPOINT_ID = process.env.SPEECH_ENDPOINT_ID;
export const SPEECH_LANGUAGE = process.env.SPEECH_LANGUAGE;
export const MHVCMARKETPLACE = 'mhvcmarketplace';
export const WOODLANDS = 'woodlands';
export const BASIC = 'basic';
export const SOAP = 'soap';
export const is_chat_enabled = false;

export const APPS_VARIANTS = {  
    "basic": {
        todayVisitPage: false,
        allergies: true
    },
    "soap": {
        todayVisitPage: true,
        allergies: false
    }
}

export const APPS_FEATURES = {
    "woodlands": {
        call_next_btn: true,
        phr: true,
        pin_based_login: false,
        show_token_on_queue: true,
        show_opdconsult_flag_on_queue: false,
        header_powered_by: true,
        reshedule_appointment: true,
        aside_test_result: true,
        aside_all_prescriptions: false,
        todayVisitSoap: {
            keyfindings: true
        },
        /** Two calendar pages one for woodland one for marketplace  */
        calendarPage: true,
        call_label: 'CALL',
        call_start_consult_label: 'CALL',
        select_doctor_dropdown: true, // for nurse login dropdown of multiple doctors
    },
    "mhvcmarketplace": {
        call_next_btn: false,
        phr: false,
        pin_based_login: true,
        show_token_on_queue: false,
        show_opdconsult_flag_on_queue: true,
        header_powered_by: false,
        reshedule_appointment: false,
        aside_test_result: false,
        aside_all_prescriptions: true,
        todayVisitSoap: {
            keyfindings: false
        },
        /** Two calendar pages one for woodland one for marketplace  */
        calendarPage: false,
        call_label: 'RESUME CONSULT',
        call_start_consult_label: 'START CONSULT',
        select_doctor_dropdown: false, // for nurse login dropdown of multiple doctors
    }
};

// IPD - FORMS - START

export const IPD_FORMS_STATUS = {
    "inprogress": "In Progress",
    "authorized": "Authorized",
    "unauthorized": "Unauthorized",
    "error": "In Error",
}

// IPD - FORMS - END

export const APPS_FEATURES_LIST = APPS_FEATURES[MYHC_APPTYPE];

export const VACCINATION_AGE_MESSAGE = 'Please add age of the patient to proceed.';
export const AVERAGE_BSA_FOR_MALE = 1.9;
export const AVERAGE_BSA_FOR_FEMALE = 1.6;
export const IS_PAEDIATRICS = [17, 25, 36, 42, 49, 50, 56, 61, 69, 80, 110, 111, 150, 152, 163, 164, 165, 93, 112];
export const PAEDRATICAGELIMIT = 17;
export const PAEDRATICVACCINEID = 32;
export const BSA_CALCULATE = (V001, V002) => { let $weight = parseFloat(V002); let $height = parseFloat(V001); let $bsa = Math.sqrt(($weight * $height) / 3600); if (!isNaN($bsa)) { return $bsa.toFixed(1) } else { return ''; } }
export const enumHttpData = Object.freeze({
    OK: 200,
});

export const DEFAULT_LIMIT_FOR_LIST = 20;


export const BLOOD_MASTER_PAGINATION = { pageSize: 10 }
export const PAGE_PAGINATION = 10;

export const  NEW_VITAL_ORDER = [
    {
        "vital_id": 1,
        "display_order": 1
    },
    {
        "vital_id": 2,
        "display_order": 2
    },
    {
        "vital_id": 3,
        "display_order": 3
    },
    {
        "vital_id": 4,
        "display_order": 4
    },
    {
        "vital_id": 5,
        "display_order": 5
    },
    {
        "vital_id": 7,
        "display_order": 6
    },
    {
        "vital_id": 8,
        "display_order": 7
    },
    {
        "vital_id": 9,
        "display_order": 8
    },
    {
        "vital_id": 10,
        "display_order": 9
    },
    {
        "vital_id": 11,
        "display_order": 10
    },
    {
        "vital_id": 12,
        "display_order": 11
    },
    {
        "vital_id": 13,
        "display_order": 12
    },
    {
        "vital_id": 14,
        "display_order": 13
    },
    {
        "vital_id": 15,
        "display_order": 14
    },
    {
        "vital_id": 17,
        "display_order": 15
    },
    {
        "vital_id": 18,
        "display_order": 16
    },
    {
        "vital_id": 20,
        "display_order": 17
    },
    {
        "vital_id": 21,
        "display_order": 18
    },
    {
        "vital_id": 22,
        "display_order": 19
    },
    {
        "vital_id": 23,
        "display_order": 20
    },
    {
        "vital_id": 24,
        "display_order": 21
    },
    {
        "vital_id": 25,
        "display_order": 22
    },
    {
        "vital_id": 26,
        "display_order": 23
    },
    {
        "vital_id": 27,
        "display_order": 24
    },
    {
        "vital_id": 28,
        "display_order": 25
    },
    {
        "vital_id": 29,
        "display_order": 26
    },
    {
        "vital_id": 30,
        "display_order": 27
    },
    {
        "vital_id": 31,
        "display_order": 28
    },
    {
        "vital_id": 32,
        "display_order": 29
    },
    {
        "vital_id": 33,
        "display_order": 30
    },
    {
        "vital_id": 34,
        "display_order": 31
    },
    {
        "vital_id": 35,
        "display_order": 32
    },
    {
        "vital_id": 36,
        "display_order": 33
    },
    {
        "vital_id": 37,
        "display_order": 34
    },
    {
        "vital_id": 38,
        "display_order": 35
    },
    {
        "vital_id": 39,
        "display_order": 36
    },
    {
        "vital_id": 40,
        "display_order": 37
    },
    {
        "vital_id": 41,
        "display_order": 38
    },
    {
        "vital_id": 42,
        "display_order": 39
    },
    {
        "vital_id": 43,
        "display_order": 40
    },
    {
        "vital_id": 44,
        "display_order": 41
    },
    {
        "vital_id": 56,
        "display_order": 42
    },
    {
        "vital_id": 57,
        "display_order": 43
    }
  ]


export const IS_PAC_CLEARANCE_REQUIRED = [18,5];
export const FACILITY_DISCHARGE_TYPE_DOR_NOT_REQUIRED = [11,12,13,14];

export const ADMITTING_PRACTITIONER_DETAILS_PRINT = [5,11,12,13,14];

export const addTimeZoneToDate = (dateValue, timezoneOffsetMinutes) => {
    let newDate = new Date(dateValue);
    let mins = timezoneOffsetMinutes;
    newDate.setMinutes(newDate.getMinutes() + mins);
    newDate = new Date(newDate);
    return newDate;
}

export const FREQUENCY_MONITOR_OPTIONS = [
    {id: 0, description: "Every 5 minutes"},
    {id: 1, description: "Every 10 minutes"},
    {id: 2, description: "Every 15 minutes"},
    {id: 3, description: "½ hourly"},
    {id: 4, description: "Every 1 hourly"},
    {id: 5, description: "Every 2 hourly"},
    {id: 6, description: "Every 3 hourly"},
    {id: 7, description: "Every 4 hourly"},
    {id: 8, description: "Every 5 hourly"},
    {id: 9, description: "Every 6 hourly"},
    {id: 10, description: "Every 8 hourly"},
    {id: 11, description: "Every 12 hourly"}   
]

export const EYE_OPEN_OPTIONS = [
    {id: 1, description: "1 No Response"},
    {id: 2, description: "2 To pain"},
    {id: 3, description: "3 to speech"},
    {id: 4, description: "4 Spontaneously"}   
]

export const MOTOR_OPTIONS = [
    {id: 1, description: "1 No response"},
    {id: 2, description: "2 Abnormal Extension"},
    {id: 3, description: "3 abnormal flexion"},
    {id: 4, description: "4 flex to withdraw from pain"},
    {id: 5, description: "5 Moves to localised pain"},
    {id: 6, description: "6 Obeys Commands"}   
]

export const STATUS_NCP = {
    1: "OPEN",
    2: "CLOSED"
}

export const VERBAL_OPTIONS = [
    {id: 1, description: "1 No response"},
    {id: 2, description: "2 incomprehensible sounds"},
    {id: 3, description: "3 inappropriate"},
    {id: 4, description: "4 Confused"},
    {id: 5, description: "5 Oriented"} 
]

export const MEWS_CHART = [
    {id: 'eyeopen_response', vital_display: "Eye Opening Response"},
    {id: 'motor_response', vital_display: "Motor Response"},
    {id: 'verbal_response', vital_display: "Verbal Response"},
    {id: 'AVPU_SCORE', vital_display: "AVPU"},
    {id: 'mews_score', vital_display: "Mews Score"},
    {id: 'gcs_score', vital_display: "GCS Score"}
]

export const AVPU_TYPES = clientEnvironment == 'paras' ?
{
    1 : 0,
    2 : 1,
    3 : 2,
    4 : 3
}
: {
    1 : 0,
    2 : 3,
    3 : 3,
    4 : 3,
    5 : 1
}


/******************* Vaccination Record API for IPD ***********************/
export const VaccinationListV2 = `${API_BASE_URL_IPD}V2/vaccination/list`;
export const VaccinationAdd = `${API_BASE_URL_IPD}vaccination/store`;
export const VaccinationItemList = `${API_BASE_URL_IPD}drug/vaccine/list`;
export const VaccinationRecordList = `${API_BASE_URL_IPD}vaccination/record/list`;
export const COMBINE_VACCINATION_DATA = (params) =>
    `${API_BASE_URL_IPD}patient/vaccination/${params.patient_id}/${params.hospital_id}`;
export const VACCINATION_AGE_MESSAGE_IPD =
  "DOB not avaiable for the patient, hence not able to fetch vaccination chart.";    
export const GET_PATIENT_DATA = `${API_BASE_URL_IPD}get_patient_data`;
export const VACCINATION_SITES = [
  { id: 1, label: "Right /Left Antero-lateral thigh Muscle" },
  { id: 2, label: "Right /Left Deltoid Muscle" },
  { id: 3, label: "Right /Left Triceps Muscle" },
  { id: 4, label: "Right /Left Intradermal" },
  { id: 5, label: "Right / Left Subcutaneous" },
  { id: 6, label: "Oral" },
  { id: 7, label: "Intradermal" },
  { id: 8, label: "Right Thigh" },
  { id: 9, label: "Left Thigh" },
  { id: 10, label: "Left Upper Arm" },
  { id: 11, label: "Left Deltoid" },
];

  /** || PAEDIATRICS APIS */
export const ALL_MILESTONES_CHILD = `${API_BASE_URL_IPD}child-milestones`;
export const MILESTONES_CHILD_SAVE = `${API_BASE_URL_IPD}patient-child-milestones/save`;
export const MILESTONES_CHILD_COMPLETE = `${API_BASE_URL_IPD}patient-child-milestones/complete`;
export const MILESTONES_CHILD_CONTINUE = `${API_BASE_URL_IPD}patient-child-milestones/continue`;
export const MILESTONES_CHILD_LIST = `${API_BASE_URL_IPD}patient-child-milestones/list`;
export const PATIENT_VITALS_ALL = (params) =>
  `${API_BASE_URL}objective/getAllVitals/${params.patient_id}`;
export const GET_VISIT_PRESCRIPTION_PDF = (params) =>
  `${API_BASE_URL}objective/getVisitPrescriptionPdf/${params.hospital_id}/${params.patient_id}/${params.reference_type}/${params.reference_id}`;



// 1.Requested-    BR
// 2.Completed-   BC
// 3.Cancelled-    BCN
// 4.Allocated-   BA
// 5.Sample Collected-    BSC
// 6.Cross Matching-    BCM
// 7.Blood Unit Issued-    BUI
// 8.Partial Issue-    BPI
// 9.Complete Issue-    BCI
// 10.Complete Issue Received-    BIR
// 11. Partial Allocated -   BPA
// 12. Partial Cross Matching-    BPCM
